 /*!----------------------------------------------
 DO NOT EDIT THIS FILE!

 This file is compiled from the CertifySite Solution and any changes
 made here will be lost the next time it is re-compiled. If you need to
 make a change and don't have access to the CertifySite solution, ask
 someone who does.

 DO NOT EDIT THIS FILE!
 ----------------------------------------------*/

var localStorageSupported = (function() {
	try {
		localStorage.setItem('test', 1);
		localStorage.removeItem('test');
		sessionStorage.setItem('test', 1);
		sessionStorage.removeItem('test', 1);
		return true;
	} catch (e) {
		return false;
	}
})();

if (!(window.console)) {
	console = {
		log: function() { },
		debug: function() { },
		info: function() { },
		warn: function() { },
		error: function() { }
	};
}

// Date.now polyfill for Less than IE9
Date.now = Date.now || function() { return +new Date(); };

// Bind polyfill
Function.prototype.bind = function() {
	var fn = this,
       args = Array.prototype.slice.call(arguments),
       object = args.shift();
	return function() {
		return fn.apply(object,
      args.concat(Array.prototype.slice.call(arguments)));
	};
};

// Array indexOf polyfill
if (!Array.prototype.indexOf) {
	Array.prototype.indexOf = function(obj, start) {
		for (var i = (start || 0), j = this.length; i < j; i++) {
			if (this[i] === obj) { return i; }
		}
		return -1;
	};
}


// **************************************************************************************************
// Local + session storage polyfill. Always use these methods to access localstorage because
// LocalStorage is not available on older browsers, and there is some weird behavior on safari
// when browsingin private mode.
// **************************************************************************************************
var Storage = {
	local: {
		set: function(key, value) {
			try {
				localStorage[key] = value;
			}
			catch (error) {
				docCookies.setItem(key, value);
			}
		},
		get: function(key) {
			try {
				return localStorage[key];
			}
			catch (error) {
				return docCookies.getItem(key);
			}
		},
		keys: function() {
			var lsKeys = [];
			try {
				for (var key in localStorage) {
					lsKeys.push(key);
				}
				return lsKeys;
			} catch (error) {
				console.log(error);

				return docCookies.keys();
			}
		},
		remove: function(key) {
			try {
				localStorage.removeItem(key);
			} catch (error) {
				docCookies.removeItem(key);
			}
		}
	},
	session: {
		set: function(key, value) {
			try {
				sessionStorage[key] = value;
			}
			catch (error) {
				// Clear cookie after 2 minutes in lieu of being able to clear at end of session.
				docCookies.setItem(key, value, 120000);
            }
        },

		keys: function() {
			var ssKeys = [];
			try {
				for (var key in sessionStorage) {
					ssKeys.push(key);
				}
				return ssKeys;
			} catch (error) {
				console.log(error);

				return docCookies.keys();
			}
		},
		get: function(key) {
			try {
				return sessionStorage[key];
			}
			catch (error) {
				return docCookies.getItem(key);
			}
		},
		remove: function(key) {
			try {
				sessionStorage.removeItem(key);
			} catch (error) {
				docCookies.removeItem(key);
			}
		}
	}
};


// ES6 Promise polyfill
!function(e) { function n() { } function t(e, n) { return function() { e.apply(n, arguments) } } function o(e) { if ("object" != typeof this) throw new TypeError("Promises must be constructed via new"); if ("function" != typeof e) throw new TypeError("not a function"); this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], s(e, this) } function i(e, n) { for (; 3 === e._state;)e = e._value; return 0 === e._state ? void e._deferreds.push(n) : (e._handled = !0, void o._immediateFn(function() { var t = 1 === e._state ? n.onFulfilled : n.onRejected; if (null === t) return void (1 === e._state ? r : u)(n.promise, e._value); var o; try { o = t(e._value) } catch (i) { return void u(n.promise, i) } r(n.promise, o) })) } function r(e, n) { try { if (n === e) throw new TypeError("A promise cannot be resolved with itself."); if (n && ("object" == typeof n || "function" == typeof n)) { var i = n.then; if (n instanceof o) return e._state = 3, e._value = n, void f(e); if ("function" == typeof i) return void s(t(i, n), e) } e._state = 1, e._value = n, f(e) } catch (r) { u(e, r) } } function u(e, n) { e._state = 2, e._value = n, f(e) } function f(e) { 2 === e._state && 0 === e._deferreds.length && o._immediateFn(function() { e._handled || o._unhandledRejectionFn(e._value) }); for (var n = 0, t = e._deferreds.length; n < t; n++)i(e, e._deferreds[n]); e._deferreds = null } function c(e, n, t) { this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof n ? n : null, this.promise = t } function s(e, n) { var t = !1; try { e(function(e) { t || (t = !0, r(n, e)) }, function(e) { t || (t = !0, u(n, e)) }) } catch (o) { if (t) return; t = !0, u(n, o) } } var a = setTimeout; o.prototype["catch"] = function(e) { return this.then(null, e) }, o.prototype.then = function(e, t) { var o = new this.constructor(n); return i(this, new c(e, t, o)), o }, o.all = function(e) { var n = Array.prototype.slice.call(e); return new o(function(e, t) { function o(r, u) { try { if (u && ("object" == typeof u || "function" == typeof u)) { var f = u.then; if ("function" == typeof f) return void f.call(u, function(e) { o(r, e) }, t) } n[r] = u, 0 === --i && e(n) } catch (c) { t(c) } } if (0 === n.length) return e([]); for (var i = n.length, r = 0; r < n.length; r++)o(r, n[r]) }) }, o.resolve = function(e) { return e && "object" == typeof e && e.constructor === o ? e : new o(function(n) { n(e) }) }, o.reject = function(e) { return new o(function(n, t) { t(e) }) }, o.race = function(e) { return new o(function(n, t) { for (var o = 0, i = e.length; o < i; o++)e[o].then(n, t) }) }, o._immediateFn = "function" == typeof setImmediate && function(e) { setImmediate(e) } || function(e) { a(e, 0) }, o._unhandledRejectionFn = function(e) { "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e) }, o._setImmediateFn = function(e) { o._immediateFn = e }, o._setUnhandledRejectionFn = function(e) { o._unhandledRejectionFn = e }, "undefined" != typeof module && module.exports ? module.exports = o : e.Promise || (e.Promise = o) }(this);



// ***********
// UTILITIES
// ***********
/*
	maps query string parameters to the urlParams object for easy access.
	URLinfo object provides formatted, easier access to commonly used properties
	of the window.location object.
*/
var URLinfo = {
	href: window.location.href.toLowerCase(),
	path: window.location.pathname.substring(1).toLowerCase(),
	host: window.location.host.toLowerCase()
};

var urlParams = {};

(function() {
	var queryString = window.location.search.substring(1);
	var params = queryString.split('&');
	var pairs;

	if (queryString) {
		var i = 0;
		var numParams = params.length;
		while (i < numParams) {
			pairs = params[i].split('=');
			switch (pairs[0]) {
				case 's':
					pairs[0] = 'campaign';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'r':
					pairs[0] = 'resourceRequested';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'ls':
					pairs[0] = 'leadSource';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'lt':
					pairs[0] = 'leadType';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'rt':
					pairs[0] = 'resourceType';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'rp':
					pairs[0] = 'referralPartner';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'p':
					pairs[0] = 'pardotUrl';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'c':
					pairs[0] = 'completionUrl';
					pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
					break;
				case 'd':
						pairs[0] = 'productRequested';
						pairs[1] = pairs[1] ? decodeURIComponent(pairs[1]) : pairs[1];
						break;
			}
			urlParams[pairs[0]] = pairs[1];
			i++;
		}
	}
})();

// math helpers
function pxToPercent(pxValue, percent) {
	return pxValue * (percent / 100);
}


// check browser + browser version
var browser = (function() {
	var ua = navigator.userAgent, tem,
	M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return 'IE ' + (tem[1] || '');
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR\/(\d+)/);
		if (tem !== null) {
			return 'Opera ' + tem[1];
		}
	}
	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
		M.splice(1, 1, tem[1]);
	}
	return M.join(' ');
})();

// identify legacy IE browser
var isLegacyIE = (function() {
	var legacyStrings = ['IE 8', 'IE 7', 'IE 6', 'MSIE 8', 'MSIE 7', 'MSIE 6'];
	browser = browser.toUpperCase();
	return $.inArray(browser, legacyStrings) > -1;
})();


// Window width detection functions

var verticalScrollPresent = function() {
	return (document.documentElement.scrollHeight !== document.documentElement.clientHeight);
};

var scrollBarWidth = (function() {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'), widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
	$outer.remove();
	return 100 - widthWithScroll;
});

var getFullWindowWidth = function() {
	if (verticalScrollPresent) {
		return $(window).width() + scrollBarWidth;
	}
	return $(window).width();
};


// Layout Utilities

function removeTitleBar() {
	$('#BannerContainer').remove();
	$('.PostHeaderContainer').css({
		'width': '100%',
		'max-width': '100%',
		'border-bottom': '1px solid #ddd'
	});
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

if (typeof JSON == 'undefined') {
	/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	(function () { function t(e, n) { function c(t) { if (c[t] !== b) return c[t]; var e; if ("bug-string-char-index" == t) e = "a" != "a"[0]; else if ("json" == t) e = c("json-stringify") && c("json-parse"); else { var r; if ("json-stringify" == t) { e = n.stringify; var o = "function" == typeof e && d; if (o) { (r = function () { return 1 }).toJSON = r; try { o = "0" === e(0) && "0" === e(new i) && '""' == e(new l) && e(j) === b && e(b) === b && e() === b && "1" === e(r) && "[1]" == e([r]) && "[null]" == e([b]) && "null" == e(null) && "[null,null,null]" == e([b, j, null]) && '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}' == e({ a: [r, !0, !1, null, "\x00\b\n\f\r	"] }) && "1" === e(null, r) && "[\n 1,\n 2\n]" == e([1, 2], null, 1) && '"-271821-04-20T00:00:00.000Z"' == e(new f(-864e13)) && '"+275760-09-13T00:00:00.000Z"' == e(new f(864e13)) && '"-000001-01-01T00:00:00.000Z"' == e(new f(-621987552e5)) && '"1969-12-31T23:59:59.999Z"' == e(new f(-1)) } catch (a) { o = !1 } } e = o } if ("json-parse" == t) { if (e = n.parse, "function" == typeof e) try { if (0 === e("0") && !e(!1)) { r = e('{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}'); var u = 5 == r.a.length && 1 === r.a[0]; if (u) { try { u = !e('"	"') } catch (s) { } if (u) try { u = 1 !== e("01") } catch (h) { } if (u) try { u = 1 !== e("1.") } catch (p) { } } } } catch (g) { u = !1 } e = u } } return c[t] = !!e } e || (e = o.Object()), n || (n = o.Object()); var i = e.Number || o.Number, l = e.String || o.String, a = e.Object || o.Object, f = e.Date || o.Date, u = e.SyntaxError || o.SyntaxError, s = e.TypeError || o.TypeError, h = e.Math || o.Math, p = e.JSON || o.JSON; "object" == typeof p && p && (n.stringify = p.stringify, n.parse = p.parse); var g, y, b, a = a.prototype, j = a.toString, d = new f(-0xc782b5b800cec); try { d = -109252 == d.getUTCFullYear() && 0 === d.getUTCMonth() && 1 === d.getUTCDate() && 10 == d.getUTCHours() && 37 == d.getUTCMinutes() && 6 == d.getUTCSeconds() && 708 == d.getUTCMilliseconds() } catch (C) { } if (!c("json")) { var v = c("bug-string-char-index"); if (!d) var S = h.floor, O = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], A = function (t, e) { return O[e] + 365 * (t - 1970) + S((t - 1969 + (e = +(e > 1))) / 4) - S((t - 1901 + e) / 100) + S((t - 1601 + e) / 400) }; if ((g = a.hasOwnProperty) || (g = function (t) { var e, r = {}; return (r.__proto__ = null, r.__proto__ = { toString: 1 }, r).toString != j ? g = function (t) { var e = this.__proto__; return t = t in (this.__proto__ = null, this), this.__proto__ = e, t } : (e = r.constructor, g = function (t) { var r = (this.constructor || e).prototype; return t in this && !(t in r && this[t] === r[t]) }), r = null, g.call(this, t) }), y = function (t, e) { var n, o, c, i = 0; (n = function () { this.valueOf = 0 }).prototype.valueOf = 0, o = new n; for (c in o) g.call(o, c) && i++; return n = o = null, i ? y = 2 == i ? function (t, e) { var r, n = {}, o = "[object Function]" == j.call(t); for (r in t) o && "prototype" == r || g.call(n, r) || !(n[r] = 1) || !g.call(t, r) || e(r) } : function (t, e) { var r, n, o = "[object Function]" == j.call(t); for (r in t) o && "prototype" == r || !g.call(t, r) || (n = "constructor" === r) || e(r); (n || g.call(t, r = "constructor")) && e(r) } : (o = "valueOf toString toLocaleString propertyIsEnumerable isPrototypeOf hasOwnProperty constructor".split(" "), y = function (t, e) { var n, c = "[object Function]" == j.call(t), i = !c && "function" != typeof t.constructor && r[typeof t.hasOwnProperty] && t.hasOwnProperty || g; for (n in t) c && "prototype" == n || !i.call(t, n) || e(n); for (c = o.length; n = o[--c]; i.call(t, n) && e(n)); }), y(t, e) }, !c("json-stringify")) { var w = { 92: "\\\\", 34: '\\"', 8: "\\b", 12: "\\f", 10: "\\n", 13: "\\r", 9: "\\t" }, T = function (t, e) { return ("000000" + (e || 0)).slice(-t) }, _ = function (t) { for (var e = '"', r = 0, n = t.length, o = !v || n > 10, c = o && (v ? t.split("") : t) ; n > r; r++) { var i = t.charCodeAt(r); switch (i) { case 8: case 9: case 10: case 12: case 13: case 34: case 92: e += w[i]; break; default: if (32 > i) { e += "\\u00" + T(2, i.toString(16)); break } e += o ? c[r] : t.charAt(r) } } return e + '"' }, N = function (t, e, r, n, o, c, i) { var l, a, f, u, h, p, d, C, v; try { l = e[t] } catch (O) { } if ("object" == typeof l && l) if (a = j.call(l), "[object Date]" != a || g.call(l, "toJSON")) "function" == typeof l.toJSON && ("[object Number]" != a && "[object String]" != a && "[object Array]" != a || g.call(l, "toJSON")) && (l = l.toJSON(t)); else if (l > -1 / 0 && 1 / 0 > l) { if (A) { for (u = S(l / 864e5), a = S(u / 365.2425) + 1970 - 1; A(a + 1, 0) <= u; a++); for (f = S((u - A(a, 0)) / 30.42) ; A(a, f + 1) <= u; f++); u = 1 + u - A(a, f), h = (l % 864e5 + 864e5) % 864e5, p = S(h / 36e5) % 24, d = S(h / 6e4) % 60, C = S(h / 1e3) % 60, h %= 1e3 } else a = l.getUTCFullYear(), f = l.getUTCMonth(), u = l.getUTCDate(), p = l.getUTCHours(), d = l.getUTCMinutes(), C = l.getUTCSeconds(), h = l.getUTCMilliseconds(); l = (0 >= a || a >= 1e4 ? (0 > a ? "-" : "+") + T(6, 0 > a ? -a : a) : T(4, a)) + "-" + T(2, f + 1) + "-" + T(2, u) + "T" + T(2, p) + ":" + T(2, d) + ":" + T(2, C) + "." + T(3, h) + "Z" } else l = null; if (r && (l = r.call(e, t, l)), null === l) return "null"; if (a = j.call(l), "[object Boolean]" == a) return "" + l; if ("[object Number]" == a) return l > -1 / 0 && 1 / 0 > l ? "" + l : "null"; if ("[object String]" == a) return _("" + l); if ("object" == typeof l) { for (t = i.length; t--;) if (i[t] === l) throw s(); if (i.push(l), v = [], e = c, c += o, "[object Array]" == a) { for (f = 0, t = l.length; t > f; f++) a = N(f, l, r, n, o, c, i), v.push(a === b ? "null" : a); t = v.length ? o ? "[\n" + c + v.join(",\n" + c) + "\n" + e + "]" : "[" + v.join(",") + "]" : "[]" } else y(n || l, function (t) { var e = N(t, l, r, n, o, c, i); e !== b && v.push(_(t) + ":" + (o ? " " : "") + e) }), t = v.length ? o ? "{\n" + c + v.join(",\n" + c) + "\n" + e + "}" : "{" + v.join(",") + "}" : "{}"; return i.pop(), t } }; n.stringify = function (t, e, n) { var o, c, i, l; if (r[typeof e] && e) if ("[object Function]" == (l = j.call(e))) c = e; else if ("[object Array]" == l) { i = {}; for (var a, f = 0, u = e.length; u > f; a = e[f++], l = j.call(a), ("[object String]" == l || "[object Number]" == l) && (i[a] = 1)); } if (n) if ("[object Number]" == (l = j.call(n))) { if (0 < (n -= n % 1)) for (o = "", n > 10 && (n = 10) ; o.length < n; o += " "); } else "[object String]" == l && (o = 10 >= n.length ? n : n.slice(0, 10)); return N("", (a = {}, a[""] = t, a), c, i, o, "", []) } } if (!c("json-parse")) { var U, J, m = l.fromCharCode, x = { 92: "\\", 34: '"', 47: "/", 98: "\b", 116: "	", 110: "\n", 102: "\f", 114: "\r" }, M = function () { throw U = J = null, u() }, F = function () { for (var t, e, r, n, o, c = J, i = c.length; i > U;) switch (o = c.charCodeAt(U)) { case 9: case 10: case 13: case 32: U++; break; case 123: case 125: case 91: case 93: case 58: case 44: return t = v ? c.charAt(U) : c[U], U++, t; case 34: for (t = "@", U++; i > U;) if (o = c.charCodeAt(U), 32 > o) M(); else if (92 == o) switch (o = c.charCodeAt(++U)) { case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114: t += x[o], U++; break; case 117: for (e = ++U, r = U + 4; r > U; U++) o = c.charCodeAt(U), o >= 48 && 57 >= o || o >= 97 && 102 >= o || o >= 65 && 70 >= o || M(); t += m("0x" + c.slice(e, U)); break; default: M() } else { if (34 == o) break; for (o = c.charCodeAt(U), e = U; o >= 32 && 92 != o && 34 != o;) o = c.charCodeAt(++U); t += c.slice(e, U) } if (34 == c.charCodeAt(U)) return U++, t; M(); default: if (e = U, 45 == o && (n = !0, o = c.charCodeAt(++U)), o >= 48 && 57 >= o) { for (48 == o && (o = c.charCodeAt(U + 1), o >= 48 && 57 >= o) && M() ; i > U && (o = c.charCodeAt(U), o >= 48 && 57 >= o) ; U++); if (46 == c.charCodeAt(U)) { for (r = ++U; i > r && (o = c.charCodeAt(r), o >= 48 && 57 >= o) ; r++); r == U && M(), U = r } if (o = c.charCodeAt(U), 101 == o || 69 == o) { for (o = c.charCodeAt(++U), 43 != o && 45 != o || U++, r = U; i > r && (o = c.charCodeAt(r), o >= 48 && 57 >= o) ; r++); r == U && M(), U = r } return +c.slice(e, U) } if (n && M(), "true" == c.slice(U, U + 4)) return U += 4, !0; if ("false" == c.slice(U, U + 5)) return U += 5, !1; if ("null" == c.slice(U, U + 4)) return U += 4, null; M() } return "$" }, k = function (t) { var e, r; if ("$" == t && M(), "string" == typeof t) { if ("@" == (v ? t.charAt(0) : t[0])) return t.slice(1); if ("[" == t) { for (e = []; t = F(), "]" != t; r || (r = !0)) r && ("," == t ? (t = F(), "]" == t && M()) : M()), "," == t && M(), e.push(k(t)); return e } if ("{" == t) { for (e = {}; t = F(), "}" != t; r || (r = !0)) r && ("," == t ? (t = F(), "}" == t && M()) : M()), "," != t && "string" == typeof t && "@" == (v ? t.charAt(0) : t[0]) && ":" == F() || M(), e[t.slice(1)] = k(F()); return e } M() } return t }, D = function (t, e, r) { r = E(t, e, r), r === b ? delete t[e] : t[e] = r }, E = function (t, e, r) { var n, o = t[e]; if ("object" == typeof o && o) if ("[object Array]" == j.call(o)) for (n = o.length; n--;) D(o, n, r); else y(o, function (t) { D(o, t, r) }); return r.call(t, e, o) }; n.parse = function (t, e) { var r, n; return U = 0, J = "" + t, r = k(F()), "$" != F() && M(), U = J = null, e && "[object Function]" == j.call(e) ? E((n = {}, n[""] = r, n), "", e) : r } } } return n.runInContext = t, n } var e = "function" == typeof define && define.amd, r = { "function": !0, object: !0 }, n = r[typeof exports] && exports && !exports.nodeType && exports, o = r[typeof window] && window || this, c = n && r[typeof module] && module && !module.nodeType && "object" == typeof global && global; if (!c || c.global !== c && c.window !== c && c.self !== c || (o = c), n && !e) t(o, n); else { var i = o.JSON, l = o.JSON3, a = !1, f = t(o, o.JSON3 = { noConflict: function () { return a || (a = !0, o.JSON = i, o.JSON3 = l, i = l = null), f } }); o.JSON = { parse: f.parse, stringify: f.stringify } } e && define(function () { return f }) }).call(this);
}
// ***********
// ANALYTICS
// ***********
var preventTracking = Storage.session.get('preventTracking') || (function() {
	if (urlParams.track) { return false; }
	if (window.location.hostname.indexOf('certify.com') == -1 && window.location.hostname !== 'localhost') {
		return true;
	}
})();

function gaEvent(category, action, label, value) {
	if (preventTracking) {
		return false;
	}
	var eventLabel = label || '';
	if (value) {
		ga('send', 'event', category, action, eventLabel, value);
	} else {
		ga('send', 'event', category, action, eventLabel);
	}
}

function reportErrorToGA(error, category, type) {
	gaEvent(category, type, error.message);
	console.log(error);
}

$(document).ready(function () {
    setTimeout(function () {
        var $isFloatingLabelsPresent = $('.form--floating-labels').length;
   
    //.form.form--float is present on page
    if ($isFloatingLabelsPresent) {
        floatFormLabels();
    }

    function floatFormLabels() {

        //Delay script to make sure select element inputs are added
        setTimeout(function () {
            var $form = $('.form--floating-labels'),
                $fields = $form.find('.formField');

            //Fade in demo request form when form is ready (delayed slightly to make sure all inputs are there)
            $form.addClass('show');

            //When field is in focus...
            $fields.on('focus', function (e) {
                var $input = $(this),
                    $wrap = $input.parent('.js-float-label');

                //Adds color to floating label
                $wrap.addClass('focus');

                //Activate floating label
                activateLabel($input, $wrap);
            });

            //When field looses focus..
            $fields.on('blur', function (e) {
                var $input = $(this),
                    $wrap = $input.parent('.js-float-label'),
                    isEmpty = $input.val() === '';

                $wrap.removeClass('focus');

                //if input is empty then remove floating-label
                if (isEmpty) {
                    deactivateLabel($input, $wrap);
                }
                else {
                    //If input is filled and is the country label activate phone label since its been changed
                    if ($input.attr('name') == 'ac-country') {
                        $input = $('#phone');
                        $wrap = $input.parent('.js-float-label');

                        activateLabel($input, $wrap);

                        //Check if State is International, if so activate label
                        var $state = $('#ac-state');
                        var $stateWrap = $state.parent('.js-float-label');
                        var $stateDisabled = $('#ac-state').attr('disabled');

                        if ($stateDisabled == 'disabled') {
                            activateLabel($state, $stateWrap);
                        }
                    }
                }
            });

            //Activate label-float and remove placeholder text
            function activateLabel($input, $wrap) {
                var $label = $wrap.find('label'),
                    $labelHeight = $label.height(),
                    $activate = true;

                //Makes label-float visible
                $wrap.addClass('has-floating-label');

                //If label is larger than one line, then apply some style adjustments relative to height
                if ($labelHeight > 15) {
                    labelFieldSpacing($activate, $labelHeight, $label, $wrap, $input);
                }

                //Remove placeholder text in input
                $input.attr('placeholder', '');

                // Animate the label-float element to top of input & Mark as 'isActive'
                setTimeout(function () {
                    $wrap.addClass('animate');
                }, 50);
            };

            //Replace label-float with placeholder text
            function deactivateLabel($input, $wrap) {
                var $label = $wrap.find('label'),
                    $labelHeight = $label.height(),
                    $labelTxt = $wrap.find('.floating-label').text(),
                    $activate = false;

                if ($labelHeight > 15) {
                    labelFieldSpacing($activate, $labelHeight, $label, $wrap, $input)
                }

                $wrap.removeClass('animate');

                //Hide floating label and add placeholder text back in
                setTimeout(function () {
                    $wrap.removeClass('has-floating-label');
                    $input.attr('placeholder', $labelTxt);
                }, 50);
            }

            function labelFieldSpacing($activate, $labelHeight, $label, $wrap, $input) {
                if ($activate) {
                    var marginAdjust = $labelHeight + 4,
                        positionAdjust = $labelHeight - 8;

                    if ($(window).width() < 765) {
                        marginAdjust = $labelHeight + 5;
                    }

                    $label.attr('style', 'top: -' + positionAdjust + 'px');
                    $wrap.attr('style', 'margin-top:' + marginAdjust + 'px');

                    //Make input regular height while label is floating (no placeholder)
                    $input.attr('style', 'max-height: 53px');
                }
                else {
                    $input.removeAttr('style');
                    $label.attr('style', 'top: 0;');
                    $wrap.removeAttr('style');
                    $label.removeAttr('style');
                }
            }
        }, 500);

    };
    }, 500);
});
//Free Trial adjustments
$(document).ready(function () {

    var placeholder = "Select one or more";

    //Set up supporting elements if they don't exist (Free Trial page)
    pageSetup(placeholder);

    //Password Field, space for password status label
    $('#registrationInfo #pwCell .formField').on('input', function () {
        $(this).parent('#pwCell').addClass('active');
    });

    $('#registrationInfo #pwStatus').removeAttr("style");

    $('#registrationInfo #pwCell .formField').keydown(function () {
        if ($(this).val() == "") {
            $(this).parent('#pwCell').removeClass('active');
        }
    });

    //Resize form table on mobile (Free Trial)
    if ($(window).width() < 765) {
        $("#registrationInfo").attr("width", "100%");
        $("#WizNavButtonsTable").attr("width", "100%");
        var leftMargin = $(".objTextPanelTable-table-margin").find("tr:nth-of-type(2) td:first");
        $(leftMargin).css("display", "none");
        $('td.left-table-margin').remove();
        $('td.left-table-margin').css("display", "none");
    }

    function pageSetup(placeholder) {
        var isFreeTrial = $("#registrationInfoContent").length > 0;

        if (isFreeTrial == true) {
            var origDD = $(".multi-select-dropdown");

            $(origDD).wrap("<div class='multi-select-wrap'></div>");
            $('.multi-select-wrap').wrap("<div class='multi-select-items'></div>");
            $(origDD).before("<input class='formField multi-select-field placeholder' name='ctl00$Product_Interest__c' type='text' data-role='none' aria-required='true'>");
            $(origDD).before("<div class='multi-bubbles-collection hide'></div>");
            $(origDD).find("option").addClass("multi-option");
            $(origDD).find("option[value='" + placeholder + "']").addClass("ignore");

            var multiSelectInner = $(".multi-select-dropdown").html();
            var optionInner = $('.multi-option').html();

            $(origDD).replaceWith($('<div id="Product_Interest_field" class="formField multiselect multi-select-dropdown" data-enhance="false" data-role="none">' + multiSelectInner + '</div>'));

            $('.multi-option').each(function () {
                var value = $(this).attr("value"),
                    optionInner = $(this).html(),
                    isIgnore = $(this).text(),
                    isEmpty = $(this).text() == "";

                if (isIgnore == placeholder) {
                    $(this).replaceWith($('<label class="multi-option ignore">' + optionInner + '</div>'));
                } else {
                    $(this).replaceWith($('<label class="multi-option" value="' + value + '">' + optionInner + '</div>'));
                }

                if (isEmpty) {
                    $(this).remove();
                }
            })

            var newDD = $('.multi-select-dropdown');

            $(newDD).find('label[value=""]').remove();
            $(newDD).find("label:first-of-type").attr("value", "");
            $(newDD).find("label").wrapAll("<div class='multiselect-wrap hide' />");
            $(newDD).find('label:not(".ignore")').prepend('<input type="checkbox" name="option[]" />');
        }
    }
});
// REPLACE "LEVERDEMO" WITH YOUR COMPANY NAME BELOW
url = 'https://api.lever.co/v0/postings/certify?department=Certify&department=Tallie'


//Setting up the structure for each job posting
function createJobs(_data) {

    //Checking for potential Lever source or origin parameters
    var pageUrl = window.location.href;
    var leverParameter = '';
    var trackingPrefix = '?lever-'

    if (pageUrl.indexOf(trackingPrefix) >= 0) {
        // Found Lever parameter
        var pageUrlSplit = pageUrl.split(trackingPrefix);
        leverParameter = '?lever-' + pageUrlSplit[1];
    }

    for (i = 0; i < _data.length; i++) {
        var posting = _data[i]
        var title = posting.text
        var description = posting.description

        //Grab only second paragraph
        var html = $.parseHTML(description);
        var string = $(html).eq(2).text();

        //Making each job description shorter than 250 characters
        var shortDescription = $.trim(string).substring(0, 250)
            .replace('\n', ' ') + "...";
        var location = posting.categories.location
        var department = posting.categories.department;
        var commitment = posting.categories.commitment
        var team = posting.categories.team
        var link = posting.hostedUrl + leverParameter

        $('#jobs-container .jobs-list').append(
            '<div class="job ' + team + ' ' + commitment + '">' +
            '<a class="job-title" href="' + link + '"">' + title + '</a>' +
            '<div class="job-subtitle"><span class="tags">' + location + '</span></div>' +
            '<div class="description">' + shortDescription + '</div>' +
            '<div class="job-button"><a class="btn btn-cta btn-orange" target="_blank" href="' + link + '">View Job Details & Apply</a></div>' +
            '</div>'
        );
    }
}

//Fetching job postings from Lever's postings API
$.ajax({
    dataType: "json",
    url: url,
    success: function (data) {
        createJobs(data);
    }
});


$(function () {
    $("#Form1").find("input[type='submit']").click(function () {
        var email = $("#Form1")
            .find("input[name='email']")
            .val();

        window["Bizible"] = window["Bizible"] || {
            _queue: [],
            Push: function (o, p) {
                this._queue.push({
                    type: o,
                    data: p
                });
            }
        };
        Bizible.Push("User", {
            eMail: email // required
        });
    });

    //Multi-select field dropdown JS
    $(document).ready(function () {

        //Global Variables
        var multiItems = $(".multi-select-items"),
            multiWrap = $(".multi-select-wrap"),
            multiSelect = $(".multi-select-dropdown"),
            multiDD = $(".multiselect-wrap"),
            multiOption = $("label", multiDD),
            optionCheckbox = $('input[type="checkbox"]', multiDD),
            bubbleCollection = $(".multi-bubbles-collection"),
            field = $(".multi-select-field"),
            placeholder = "Select one or more",
            submit = $('input[type="submit"]');

        adjustHeight();
        
        $(multiSelect).closest(".inputWrap").addClass("inputMultiple");

        //Prevent multi-field from accepting text/interaction
        $(field).focus(function (e) {
            $(this).blur();
        });

        $(multiItems).click(function (event) {
            event.stopPropagation();
            $(multiDD).toggleClass('hide');
        });

        $(window).click(function () {
            $(multiDD).addClass('hide');
        });

        //User selected an option
        $(multiOption).on("change", function () {
            var selected = $(this).attr("value"),
                isSelected = $(".multi-option:contains(" + selected + ")"),
                isChecked = $(isSelected).find('input[type="checkbox"]').is(":checked"),
                choiceIgnore = $(isSelected).hasClass("ignore");

            //If option is checked...
            if (isChecked == true) {

                //Add grey text bubble under field
                addBubble(selected, choiceIgnore);
            }
            //If it is not checked...
            else {

                //Remove grey text bubble under field
                removeBubble(selected);
            }

            //Remove bubble options
            $(".bubble-close").on("click", function (event) {
                event.stopPropagation();
                var selected = $(this).parent(".multi-bubble").attr("value");

                removeBubble(selected);

                //If last multi-bubble was deleted, show placeholder text
                if ($(".multi-bubble").length == 0) {
                    lastBubble();
                }
            });
        });

        function addBubble(selected, choiceIgnore) {
            var bubble = '<span class="multi-bubble hide" value="' + selected + '"><span class="bubble-content">' + selected + '</span><span class="bubble-close"></span></span>',
                allBubbles = $(".multi-bubble:not(.ignore)"),
                bubbleValue = $(".multi-bubble").val(),
                bubbleExists = false,
                anybubbles = false;

            //Check to make sure option wasn't already selected
            $(allBubbles).each(function () {
                var checkValue = $(this).attr("value");
                if (checkValue == selected) {
                    bubbleExists = true;
                }
            });

            //If bubble option wasn't already selected and "(choose one or more)" wasn't selected
            if (bubbleExists === false && choiceIgnore == false) {
                //Place bubble in collection under dropdown
                $(bubbleCollection).append(bubble);
                $(bubbleCollection).removeClass("hide");
                adjustHeight();
                addSelected(selected, allBubbles);
            }
        }

        function removeBubble(selected) {
            var target = $('.multi-bubble:contains("' + selected + '")');
            $(target).remove();

            //Remove bubble selection from field text
            removeSelected(selected);

            //Uncheck checkbox for selected
            uncheckSelected(selected);
        }

        //Adding selected to field string
        function addSelected(selected, allBubbles) {
            var added = selected;

            //If any bubbles exist...
            if ($(allBubbles).length > 0) {
                //Add bubble selection to field text by
                //converting to array, add option, then convert to string
                var fieldVal = $(field).val();
                var array = fieldVal.split(", ");
                array.push(added);
                var newFieldVal = array.join(", ");

                //Show new array in field
                $(field).val(newFieldVal);
            } else {
                //First bubble added 
                //Add bubble selection to field text without spaces
                field.val("");
                field.val(field.val() + selected);
                $(field).removeClass("placeholder");
            }
        }

        function removeSelected(selected) {
            //Remove selection from field text by
            //converting to array, remove option, then convert back to string
            var fieldVal = $(field).val(),
                array = fieldVal.split(", "),
                removed = selected;

            array = jQuery.grep(array, function (value) {
                return value != removed;
            });

            var newFieldVal = array.join(", ");
            $(field).val(newFieldVal);
            adjustHeight();
        }

        //Check selected (when bubbles exists on checkData function)
        function checkSelected(productInterest) {
            var added = productInterest,
                empty = true;

            var array = added.split(", ");
            var i;
            for (i = 0; i < array.length; ++i) {
                var val = array[i];
                var optionTarget = $('.multi-option[value="'+ val +'"');

                $(optionTarget).find('input[type="checkbox"]').prop("checked", true);
            }
        }

        function uncheckSelected(selected) {
            var removed = selected,
                empty = true;

            //Uncheck removed option from select dropdown
            $(multiOption).each(function () {
                var target = $(this).text(),
                    isChecked = $(this)
                        .find('input[type="checkbox"]')
                        .is(":checked");

                if (target == removed) {
                    $(this)
                        .find('input[type="checkbox"]')
                        .prop("checked", false);
                    $(this).removeClass("selected");
                }

                if (isChecked == true) {
                    empty = false;
                }
            });

            if (empty == true) {
                $(field).val(placeholder);
                $(field).addClass("placeholder");
            }

            //If last multi-bubble was deleted, show placeholder text
            if ($(".multi-bubble").length == 0) {
                lastBubble();
            }
        }

        function lastBubble() {
            $(bubbleCollection).addClass("hide");
            $(field).val(placeholder);
            $(field).addClass("placeholder");
            adjustHeight();
        }

        //Adjust field height for when options wrap to next line
        function adjustHeight() {

            setTimeout(function () {
                $(multiWrap).removeAttr("style");

                var bubblesHide = $(bubbleCollection).hasClass('hide');

                if (bubblesHide == true) {

                    var fieldHeight = $('.multi-select-field').height(),
                        sheight = parseFloat(fieldHeight),
                        newHeight = sheight;
                } else {
                    var bubblesHeight = $(bubbleCollection).height(),
                        cheight = parseFloat(bubblesHeight),
                        fieldHeight = $('.multi-select-field').height(),
                        sheight = parseFloat(fieldHeight),
                        newHeight = cheight + sheight + 30;
                }

                //Increase height of multi-select-dropdown to contain all multi-bubbles
                $(multiWrap).css("height", newHeight);

            }, 100);
        }
    });
});
$(document).ready(function () {
    //All Select Fields: Darken text color if ignored option (first option) isn't selected. Otherwise keep the color light grey
    var emptyOptions = $('option:empty'),
        ignoreOptions = $('select').find('option:contains("Select")'),
        selectFields = $('select.formField');

    $(emptyOptions).each(function () {
        $(this).remove();
    });

    $(ignoreOptions).addClass('ignore');
    $(ignoreOptions).attr("value", "");
    $(ignoreOptions).removeAttr("disabled");

    //Select Setup
    $(selectFields).each(function () {
        var dropdown = $(this);
            selected = $(dropdown).val(),
            selectOption = $(dropdown).find('option[value="' + selected + '"]'),
            ignoreSelected = $(dropdown).find('.ignore').attr("selected");

        if ($(selectOption).hasClass('ignore') || ignoreSelected !== false) {
            $(dropdown).addClass('placeholder');
        }
        else {
            $(dropdown).removeClass('placeholder');
        }
    });

    //All Select Fields on change
    $('select').on("change", function () {
        var dropdown = $(this),
            selectedVal = $(dropdown).val(),
            isSelected = $(dropdown).find("option[value='" + selectedVal + "']"),
            prevOption = $(dropdown).find('option[selected="selected"]');

        //If first ignored option was not selected
        if ($(isSelected).hasClass('ignore') == false) {
            $(dropdown).removeClass('placeholder');
            $(prevOption).removeAttr('selected');
            $(isSelected).attr("selected", "selected");
            $(dropdown).val(selectedVal);
        }
        else {
            $(this).addClass('placeholder');
        }
    });

    $('.ac-select').removeClass('placeholder');

});

/*
Version: 1.0.9
Documentation: http://baymard.com/labs/country-selector#documentation
Copyright (C) 2011 by Jamie Appleseed, Baymard Institute (baymard.com)
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/
(function() {
  var settings = {
    'sort': false,
    'sort-attr': 'data-priority',
    'sort-desc': false,
    'autoselect': true,
    'alternative-spellings': true,
    'alternative-spellings-attr': 'data-alternative-spellings',
    'remove-valueless-options': true,
    'copy-attributes-to-text-field': true,
    'autocomplete-plugin': 'jquery_ui',
    'relevancy-sorting': true,
    'relevancy-sorting-partial-match-value': 1,
    'relevancy-sorting-strict-match-value': 5,
    'relevancy-sorting-booster-attr': 'data-relevancy-booster',
    'minLength': 0,
    'delay': 0,
    'autoFocus': true,
    handle_invalid_input: function(context) {
      var selected_finder = 'option:selected:first';
      if(context.settings['remove-valueless-options']) {
        selected_finder = 'option:selected[value!=""]:first';
      }
      context.$text_field.val(context.$select_field.find(selected_finder).text());
    },
    handle_select_field: function($select_field) {
      return $select_field.hide();
    },
    insert_text_field: function(context) {
      var $text_field = $('<input type="text"></input>');
      if(settings['copy-attributes-to-text-field']) {
        var attrs = {};
        var raw_attrs = context.$select_field[0].attributes;
        for(var i = 0;i < raw_attrs.length;i++) {
          var key = raw_attrs[i].nodeName;
          var value = raw_attrs[i].nodeValue;
          if(key !== 'name' && key !== 'id' && typeof context.$select_field.attr(key) !== 'undefined') {
            attrs[key] = value;
          }
        };
        $text_field.attr(attrs);
      }
      $text_field.blur(function() {
        var valid_values = context.$select_field.find('option').map(function(i,option) { return $(option).text(); });
        if(($.inArray($text_field.val(),valid_values) < 0) && typeof settings['handle_invalid_input'] === 'function') {
          settings['handle_invalid_input'](context);
        }
      });
      // give the input box the ability to select all text on mouse click
      if(context.settings['autoselect']) {
        $text_field.click(function() {
          this.select();
        });
      }
      var selected_finder = 'option:selected:first';
      if(context.settings['remove-valueless-options']) {
        selected_finder = 'option:selected[value!=""]:first';
      }
      return $text_field.val(context.$select_field.find(selected_finder).text())
        .insertAfter(context.$select_field);
    },
    extract_options: function($select_field) {
      var options = [];
      var $options = $select_field.find('option');
      var number_of_options = $options.length;

      // go over each option in the select tag
      $options.each(function() {
        var $option = $(this);
        var option = {
          'real-value': $option.attr('value'),
          'label': $option.text()
        }
        if(settings['remove-valueless-options'] && option['real-value'] === '') {
          // skip options without a value
        } else {
          // prepare the 'matches' string which must be filtered on later
          option['matches'] = option['label'];
          var alternative_spellings = $option.attr(settings['alternative-spellings-attr']);
          if(alternative_spellings) {
            option['matches'] += ' ' + alternative_spellings;
          }
          // give each option a weight paramter for sorting
          if(settings['sort']) {
            var weight = parseInt($option.attr(settings['sort-attr']),10);
            if(weight) {
              option['weight'] = weight;
            } else {
              option['weight'] = number_of_options;
            }
          }
          // add relevancy score
          if(settings['relevancy-sorting']) {
            option['relevancy-score'] = 0;
            option['relevancy-score-booster'] = 1;
            var boost_by = parseFloat($option.attr(settings['relevancy-sorting-booster-attr']));
            if(boost_by) {
              option['relevancy-score-booster'] = boost_by;
            }
          }


          if($option.attr('class')) {
            // **
            // CUSTOM CODE:
            // If the option is segmented add a class to filter on.
            // **
            option.type = $option.attr('class');
          }
          // add option to combined array
          options.push(option);
        }
      });
      // sort the options based on weight
      if(settings['sort']) {
        if(settings['sort-desc']) {
          options.sort(function(a,b) { return b['weight'] - a['weight']; });
        } else {
          options.sort(function(a,b) { return a['weight'] - b['weight']; });
        }
      }

      // return the set of options, each with the following attributes: real-value, label, matches, weight (optional)
      return options;
    }
  };

  var public_methods = {
    init: function(customizations) {

      if(/msie/.test(navigator.userAgent.toLowerCase()) && parseInt(navigator.appVersion,10) <= 6) {

        return this;

      } else {

        settings = $.extend(settings,customizations);

        return this.each(function() {
          var $select_field = $(this);

          var context = {
            '$select_field': $select_field,
            'options': settings['extract_options']($select_field),
            'settings': settings
          };
          
          context['$text_field'] = settings['insert_text_field'](context).attr({
          	'id': 'ac-' + $(this).attr('id'),
          	'name': 'ac-' + $(this).attr('name')
          }).addClass('formField');

          settings['handle_select_field']($select_field);

          if(typeof settings['autocomplete-plugin'] === 'string') {
            adapters[settings['autocomplete-plugin']](context);
          } else {
            settings['autocomplete-plugin'](context);
          }
        });

      }

    }
  };

  var adapters = {
    jquery_ui: function(context) {
      // loose matching of search terms
      var filter_options = function(term) {
        var split_term = term.split(' ');
        var matchers = [];
        for(var i = 0;i < split_term.length;i++) {
          if(split_term[i].length > 0) {
            var matcher = {};
            matcher['partial'] = new RegExp($.ui.autocomplete.escapeRegex(split_term[i]),"i");
            if(context.settings['relevancy-sorting']) {
              matcher['strict'] = new RegExp("^" + $.ui.autocomplete.escapeRegex(split_term[i]),"i");
            }
            matchers.push(matcher);
          }
        };

        return $.grep(context.options,function(option) {
          var partial_matches = 0;

          if(context.settings['relevancy-sorting']) {
            var strict_match = false;
            var split_option_matches = option.matches.split(' ');
          }

          var stateField = context.$select_field.attr('id') == 'state';
          for(var i = 0;i < matchers.length;i++) {

            if(matchers[i]['partial'].test(option.matches)) {

            	if ($('#ac-country') && $('#ac-state')) {
                // **
                // CUSTOM CODE:
                // Appropriately populate the State/Province list
                // according to the value set in country if both
                // country and state autocomplete fields exist
                // **
                var countryVal = $('#ac-country').val().toUpperCase();
                var optionType = option.type;

                if(countryVal && stateField) {
                  var isUS = countryVal == 'UNITED STATES OF AMERICA (USA)';
                  var isCan = countryVal == 'CANADA';
                    if (isUS && optionType == 'state') {
                    partial_matches++;
                  } else if(isCan && optionType == 'province') {
                    partial_matches++;
                  } else if(!isUS && !isCan && !optionType) {
                    partial_matches++;
                  }
                }
                else {
                  // if country is empty
                  partial_matches++;
                }
              }
              else {
                partial_matches++;
              }
            }
            if(context.settings['relevancy-sorting']) {
              for(var q = 0;q < split_option_matches.length;q++) {
                if(matchers[i]['strict'].test(split_option_matches[q])) {
                  strict_match = true;
                  break;
                }
              };
            }
          };

          if(context.settings['relevancy-sorting']) {
            var option_score = 0;
            option_score += partial_matches * context.settings['relevancy-sorting-partial-match-value'];
            if(strict_match) {
              option_score += context.settings['relevancy-sorting-strict-match-value'];
            }
            option_score = option_score * option['relevancy-score-booster'];
            option['relevancy-score'] = option_score;
          }
          return (!term || matchers.length === partial_matches);
        });
      }
      // update the select field value using either selected option or current input in the text field
      var update_select_value = function(option) {
        if(option) {
          if(context.$select_field.val() !== option['real-value']) {
            context.$select_field.val(option['real-value']);
            context.$select_field.change();
          }
        } else {
          var option_name = context.$text_field.val().toLowerCase();
          var matching_option = { 'real-value': false };
          for(var i = 0;i < context.options.length;i++) {
            if(option_name === context.options[i]['label'].toLowerCase()) {
              matching_option = context.options[i];
              break;
            }
          };
          if(context.$select_field.val() !== matching_option['real-value']) {
            context.$select_field.val(matching_option['real-value'] || '');
            context.$select_field.change();
          }
          if(matching_option['real-value']) {
            context.$text_field.val(matching_option['label']);
          }
          if(typeof context.settings['handle_invalid_input'] === 'function' && context.$select_field.val() === '') {
            context.settings['handle_invalid_input'](context);
          }
        }
      }
      // jQuery UI autocomplete settings & behavior
      context.$text_field.autocomplete({
        'minLength': context.settings['minLength'],
        'delay': context.settings['delay'],
        'autoFocus': context.settings['autoFocus'],
        source: function(request,response) {

          var filtered_options = filter_options(request.term);
          if(context.settings['relevancy-sorting']) {
            filtered_options = filtered_options.sort(function(a,b) {

              if(b['relevancy-score'] == a['relevancy-score']) {
                return b['label'] < a['label'] ? 1 : -1;
              } else {
                return b['relevancy-score'] - a['relevancy-score'];
              }
            });
          }
          response(filtered_options);
        },
        select: function(event,ui) {
          update_select_value(ui.item);
        },
        change: function(event,ui) {
          update_select_value(ui.item);
        }
      });
      // force refresh value of select field when form is submitted
      context.$text_field.parents('form:first').submit(function() {
        update_select_value();
      });
      // select current value
      update_select_value();
    }
  };

  $.fn.selectToAutocomplete = function(method) {
    if(public_methods[method]) {
      return public_methods[method].apply(this,Array.prototype.slice.call(arguments,1));
    } else if(typeof method === 'object' || !method) {
      return public_methods.init.apply(this,arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.fn.selectToAutocomplete');
    }
  };

})();
/*!
 * jQuery Validation Plugin v1.14.0
 *
 * http://jqueryvalidation.org/
 *
 * Copyright (c) 2015 Jörn Zaefferer
 * Released under the MIT license
 */
(function(factory) {
  if(typeof define === "function" && define.amd) {
    define(["jquery"],factory);
  } else {
    factory(jQuery);
  }
}(function($) {

  $.extend($.fn,{
    // http://jqueryvalidation.org/validate/
    validate: function(options) {

      // if nothing is selected, return nothing; can't chain anyway
      if(!this.length) {
        if(options && options.debug && window.console) {
          console.warn("Nothing selected, can't validate, returning nothing.");
        }
        return;
      }

      // check if a validator for this form was already created
      var validator = $.data(this[0],"validator");
      if(validator) {
        return validator;
      }

      // Add novalidate tag if HTML5.
      this.attr("novalidate","novalidate");

      validator = new $.validator(options,this[0]);
      $.data(this[0],"validator",validator);

      if(validator.settings.onsubmit) {

        this.on("click.validate",":submit",function(event) {
          if(validator.settings.submitHandler) {
            validator.submitButton = event.target;
          }

          // allow suppressing validation by adding a cancel class to the submit button
          if($(this).hasClass("cancel")) {
            validator.cancelSubmit = true;
          }

          // allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
          if($(this).attr("formnovalidate") !== undefined) {
            validator.cancelSubmit = true;
          }
        });

        // validate the form on submit
        this.on("submit.validate",function(event) {
          if(validator.settings.debug) {
            // prevent form submit to be able to see console output
            event.preventDefault();
          }
          function handle() {
            var hidden,result;
            if(validator.settings.submitHandler) {
              if(validator.submitButton) {
                // insert a hidden input as a replacement for the missing submit button
                hidden = $("<input type='hidden'/>")
                  .attr("name",validator.submitButton.name)
                  .val($(validator.submitButton).val())
                  .appendTo(validator.currentForm);
              }
              result = validator.settings.submitHandler.call(validator,validator.currentForm,event);
              if(validator.submitButton) {
                // and clean up afterwards; thanks to no-block-scope, hidden can be referenced
                hidden.remove();
              }
              if(result !== undefined) {
                return result;
              }
              return false;
            }
            return true;
          }

          // prevent submit for invalid forms or custom submit handlers
          if(validator.cancelSubmit) {
            validator.cancelSubmit = false;
            return handle();
          }
          if(validator.form()) {
            if(validator.pendingRequest) {
              validator.formSubmitted = true;
              return false;
            }
            return handle();
          } else {
            validator.focusInvalid();
            return false;
          }
        });
      }

      return validator;
    },
    // http://jqueryvalidation.org/valid/
    valid: function() {
      var valid,validator,errorList;

      if($(this[0]).is("form")) {
        valid = this.validate().form();
      } else {
        errorList = [];
        valid = true;
        validator = $(this[0].form).validate();
        this.each(function() {
          valid = validator.element(this) && valid;
          errorList = errorList.concat(validator.errorList);
        });
        validator.errorList = errorList;
      }
      return valid;
    },

    // http://jqueryvalidation.org/rules/
    rules: function(command,argument) {
      var element = this[0],
        settings,staticRules,existingRules,data,param,filtered;

      if(command) {
        settings = $.data(element.form,"validator").settings;
        staticRules = settings.rules;
        existingRules = $.validator.staticRules(element);
        switch(command) {
          case "add":
            $.extend(existingRules,$.validator.normalizeRule(argument));
            // remove messages from rules, but allow them to be set separately
            delete existingRules.messages;
            staticRules[element.name] = existingRules;
            if(argument.messages) {
              settings.messages[element.name] = $.extend(settings.messages[element.name],argument.messages);
            }
            break;
          case "remove":
            if(!argument) {
              delete staticRules[element.name];
              return existingRules;
            }
            filtered = {};
            $.each(argument.split(/\s/),function(index,method) {
              filtered[method] = existingRules[method];
              delete existingRules[method];
              if(method === "required") {
                $(element).removeAttr("aria-required");
              }
            });
            return filtered;
        }
      }

      data = $.validator.normalizeRules(
      $.extend(
        {},
        $.validator.classRules(element),
        $.validator.attributeRules(element),
        $.validator.dataRules(element),
        $.validator.staticRules(element)
      ),element);

      // make sure required is at front
      if(data.required) {
        param = data.required;
        delete data.required;
        data = $.extend({ required: param },data);
        $(element).attr("aria-required","true");
      }

      // make sure remote is at back
      if(data.remote) {
        param = data.remote;
        delete data.remote;
        data = $.extend(data,{ remote: param });
      }

      return data;
    }
  });

  // Custom selectors
  $.extend($.expr[":"],{
    // http://jqueryvalidation.org/blank-selector/
    blank: function(a) {
      return !$.trim("" + $(a).val());
    },
    // http://jqueryvalidation.org/filled-selector/
    filled: function(a) {
      return !!$.trim("" + $(a).val());
    },
    // http://jqueryvalidation.org/unchecked-selector/
    unchecked: function(a) {
      return !$(a).prop("checked");
    }
  });

  // constructor for validator
  $.validator = function(options,form) {
    this.settings = $.extend(true,{},$.validator.defaults,options);
    this.currentForm = form;
    this.init();
  };

  // http://jqueryvalidation.org/jQuery.validator.format/
  $.validator.format = function(source,params) {
    if(arguments.length === 1) {
      return function() {
        var args = $.makeArray(arguments);
        args.unshift(source);
        return $.validator.format.apply(this,args);
      };
    }
    if(arguments.length > 2 && params.constructor !== Array) {
      params = $.makeArray(arguments).slice(1);
    }
    if(params.constructor !== Array) {
      params = [params];
    }
    $.each(params,function(i,n) {
      source = source.replace(new RegExp("\\{" + i + "\\}","g"),function() {
        return n;
      });
    });
    return source;
  };

  $.extend($.validator,{

    defaults: {
      messages: {},
      groups: {},
      rules: {},
      errorClass: "error",
      validClass: "valid",
      errorElement: "label",
      focusCleanup: false,
      focusInvalid: true,
      errorContainer: $([]),
      errorLabelContainer: $([]),
      onsubmit: true,
      ignore: ":hidden",
      ignoreTitle: false,
      onfocusin: function(element) {
        this.lastActive = element;

        // Hide error label and remove error class on focus if enabled
        if(this.settings.focusCleanup) {
          if(this.settings.unhighlight) {
            this.settings.unhighlight.call(this,element,this.settings.errorClass,this.settings.validClass);
          }
          this.hideThese(this.errorsFor(element));
        }
      },
      onfocusout: function(element) {
        if(!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
          this.element(element);
        }
      },
      onkeyup: function(element,event) {
        // Avoid revalidate the field when pressing one of the following keys
        // Shift       => 16
        // Ctrl        => 17
        // Alt         => 18
        // Caps lock   => 20
        // End         => 35
        // Home        => 36
        // Left arrow  => 37
        // Up arrow    => 38
        // Right arrow => 39
        // Down arrow  => 40
        // Insert      => 45
        // Num lock    => 144
        // AltGr key   => 225
        var excludedKeys = [
          16,17,18,20,35,36,37,
          38,39,40,45,144,225
        ];

        if(event.which === 9 && this.elementValue(element) === "" || $.inArray(event.keyCode,excludedKeys) !== -1) {
          return;
        } else if(element.name in this.submitted || element === this.lastElement) {
          this.element(element);
        }
      },
      onclick: function(element) {
        // click on selects, radiobuttons and checkboxes
        if(element.name in this.submitted) {
          this.element(element);

          // or option elements, check parent select in that case
        } else if(element.parentNode.name in this.submitted) {
          this.element(element.parentNode);
        }
      },
      highlight: function(element,errorClass,validClass) {
        if(element.type === "radio") {
          this.findByName(element.name).addClass(errorClass).removeClass(validClass);
        } else {
          $(element).addClass(errorClass).removeClass(validClass);
        }
      },
      unhighlight: function(element,errorClass,validClass) {
        if(element.type === "radio") {
          this.findByName(element.name).removeClass(errorClass).addClass(validClass);
        } else {
          $(element).removeClass(errorClass).addClass(validClass);
        }
      }
    },

    // http://jqueryvalidation.org/jQuery.validator.setDefaults/
    setDefaults: function(settings) {
      $.extend($.validator.defaults,settings);
    },

    messages: {
      required: "This field is required.",
      remote: "Please fix this field.",
      email: "Please enter a valid email address.",
      url: "Please enter a valid URL.",
      date: "Please enter a valid date.",
      dateISO: "Please enter a valid date ( ISO ).",
      number: "Please enter a valid number.",
      digits: "Please enter only digits.",
      creditcard: "Please enter a valid credit card number.",
      equalTo: "Please enter the same value again.",
      maxlength: $.validator.format("Please enter no more than {0} characters."),
      minlength: $.validator.format("Please enter at least {0} characters."),
      rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
      range: $.validator.format("Please enter a value between {0} and {1}."),
      max: $.validator.format("Please enter a value less than or equal to {0}."),
      min: $.validator.format("Please enter a value greater than or equal to {0}.")
    },

    autoCreateRanges: false,

    prototype: {

      init: function() {
        this.labelContainer = $(this.settings.errorLabelContainer);
        this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
        this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
        this.submitted = {};
        this.valueCache = {};
        this.pendingRequest = 0;
        this.pending = {};
        this.invalid = {};
        this.reset();

        var groups = (this.groups = {}),
          rules;
        $.each(this.settings.groups,function(key,value) {
          if(typeof value === "string") {
            value = value.split(/\s/);
          }
          $.each(value,function(index,name) {
            groups[name] = key;
          });
        });
        rules = this.settings.rules;
        $.each(rules,function(key,value) {
          rules[key] = $.validator.normalizeRule(value);
        });

        function delegate(event) {
          var validator = $.data(this.form,"validator"),
            eventType = "on" + event.type.replace(/^validate/,""),
            settings = validator.settings;
          if(settings[eventType] && !$(this).is(settings.ignore)) {
            settings[eventType].call(validator,this,event);
          }
        }

        $(this.currentForm)
          .on("focusin.validate focusout.validate keyup.validate",
            ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
            "[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
            "[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
            "[type='radio'], [type='checkbox']",delegate)
          // Support: Chrome, oldIE
          // "select" is provided as event.target when clicking a option
          .on("click.validate","select, option, [type='radio'], [type='checkbox']",delegate);

        if(this.settings.invalidHandler) {
          $(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler);
        }

        // Add aria-required to any Static/Data/Class required fields before first validation
        // Screen readers require this attribute to be present before the initial submission http://www.w3.org/TR/WCAG-TECHS/ARIA2.html
        $(this.currentForm).find("[required], [data-rule-required], .required").attr("aria-required","true");
      },

      // http://jqueryvalidation.org/Validator.form/
      form: function() {
        this.checkForm();
        $.extend(this.submitted,this.errorMap);
        this.invalid = $.extend({},this.errorMap);
        if(!this.valid()) {
          $(this.currentForm).triggerHandler("invalid-form",[this]);
        }
        this.showErrors();
        return this.valid();
      },

      checkForm: function() {
        this.prepareForm();
        for(var i = 0,elements = (this.currentElements = this.elements()) ;elements[i];i++) {
          this.check(elements[i]);
        }
        return this.valid();
      },

      // http://jqueryvalidation.org/Validator.element/
      element: function(element) {
        var cleanElement = this.clean(element),
          checkElement = this.validationTargetFor(cleanElement),
          result = true;

        this.lastElement = checkElement;

        if(checkElement === undefined) {
          delete this.invalid[cleanElement.name];
        } else {
          this.prepareElement(checkElement);
          this.currentElements = $(checkElement);

          result = this.check(checkElement) !== false;
          if(result) {
            delete this.invalid[checkElement.name];
          } else {
            this.invalid[checkElement.name] = true;
          }
        }
        // Add aria-invalid status for screen readers
        $(element).attr("aria-invalid",!result);

        if(!this.numberOfInvalids()) {
          // Hide error containers on last error
          this.toHide = this.toHide.add(this.containers);
        }
        this.showErrors();
        return result;
      },

      // http://jqueryvalidation.org/Validator.showErrors/
      showErrors: function(errors) {
        if(errors) {
          // add items to error list and map
          $.extend(this.errorMap,errors);
          this.errorList = [];
          for(var name in errors) {
            this.errorList.push({
              message: errors[name],
              element: this.findByName(name)[0]
            });
          }
          // remove items from success list
          this.successList = $.grep(this.successList,function(element) {
            return !(element.name in errors);
          });
        }
        if(this.settings.showErrors) {
          this.settings.showErrors.call(this,this.errorMap,this.errorList);
        } else {
          this.defaultShowErrors();
        }
      },

      // http://jqueryvalidation.org/Validator.resetForm/
      resetForm: function() {
        if($.fn.resetForm) {
          $(this.currentForm).resetForm();
        }
        this.submitted = {};
        this.lastElement = null;
        this.prepareForm();
        this.hideErrors();
        var i,elements = this.elements()
          .removeData("previousValue")
          .removeAttr("aria-invalid");

        if(this.settings.unhighlight) {
          for(i = 0;elements[i];i++) {
            this.settings.unhighlight.call(this,elements[i],
              this.settings.errorClass,"");
          }
        } else {
          elements.removeClass(this.settings.errorClass);
        }
      },

      numberOfInvalids: function() {
        return this.objectLength(this.invalid);
      },

      objectLength: function(obj) {
        /* jshint unused: false */
        var count = 0,
          i;
        for(i in obj) {
          count++;
        }
        return count;
      },

      hideErrors: function() {
        this.hideThese(this.toHide);
      },

      hideThese: function(errors) {
        errors.not(this.containers).text("");
        this.addWrapper(errors).hide();
      },

      valid: function() {
        return this.size() === 0;
      },

      size: function() {
        return this.errorList.length;
      },

      focusInvalid: function() {
        if(this.settings.focusInvalid) {
          try {
            $(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
            .filter(":visible")
            .focus()
            // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
            .trigger("focusin");
          } catch(e) {
            // ignore IE throwing errors when focusing hidden elements
          }
        }
      },

      findLastActive: function() {
        var lastActive = this.lastActive;
        return lastActive && $.grep(this.errorList,function(n) {
          return n.element.name === lastActive.name;
        }).length === 1 && lastActive;
      },

      elements: function() {
        var validator = this,
          rulesCache = {};

        // select all valid inputs inside the form (no submit or reset buttons)
        return $(this.currentForm)
        .find("input, select, textarea")
        .not(":submit, :reset, :image, :disabled")
        .not(this.settings.ignore)
        .filter(function() {
          if(!this.name && validator.settings.debug && window.console) {
            console.error("%o has no name assigned",this);
          }

          // select only the first element for each name, and only those with rules specified
          if(this.name in rulesCache || !validator.objectLength($(this).rules())) {
            return false;
          }

          rulesCache[this.name] = true;
          return true;
        });
      },

      clean: function(selector) {
        return $(selector)[0];
      },

      errors: function() {
        var errorClass = this.settings.errorClass.split(" ").join(".");
        return $(this.settings.errorElement + "." + errorClass,this.errorContext);
      },

      reset: function() {
        this.successList = [];
        this.errorList = [];
        this.errorMap = {};
        this.toShow = $([]);
        this.toHide = $([]);
        this.currentElements = $([]);
      },

      prepareForm: function() {
        this.reset();
        this.toHide = this.errors().add(this.containers);
      },

      prepareElement: function(element) {
        this.reset();
        this.toHide = this.errorsFor(element);
      },

      elementValue: function(element) {
        var val,
          $element = $(element),
          type = element.type;

        if(type === "radio" || type === "checkbox") {
          return this.findByName(element.name).filter(":checked").val();
        } else if(type === "number" && typeof element.validity !== "undefined") {
          return element.validity.badInput ? false : $element.val();
        }

        val = $element.val();
        if(typeof val === "string") {
          return val.replace(/\r/g,"");
        }
        return val;
      },

      check: function(element) {
        element = this.validationTargetFor(this.clean(element));

        var rules = $(element).rules(),
          rulesCount = $.map(rules,function(n,i) {
            return i;
          }).length,
          dependencyMismatch = false,
          val = this.elementValue(element),
          result,method,rule;

        for(method in rules) {
          rule = { method: method,parameters: rules[method] };
          try {

            result = $.validator.methods[method].call(this,val,element,rule.parameters);

            // if a method indicates that the field is optional and therefore valid,
            // don't mark it as valid when there are no other rules
            if(result === "dependency-mismatch" && rulesCount === 1) {
              dependencyMismatch = true;
              continue;
            }
            dependencyMismatch = false;

            if(result === "pending") {
              this.toHide = this.toHide.not(this.errorsFor(element));
              return;
            }

            if(!result) {
              this.formatAndAdd(element,rule);
              return false;
            }
          } catch(e) {
            if(this.settings.debug && window.console) {
              console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.",e);
            }
            if(e instanceof TypeError) {
              e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
            }

            throw e;
          }
        }
        if(dependencyMismatch) {
          return;
        }
        if(this.objectLength(rules)) {
          this.successList.push(element);
        }
        return true;
      },

      // return the custom message for the given element and validation method
      // specified in the element's HTML5 data attribute
      // return the generic message if present and no method specific message is present
      customDataMessage: function(element,method) {
        return $(element).data("msg" + method.charAt(0).toUpperCase() +
          method.substring(1).toLowerCase()) || $(element).data("msg");
      },

      // return the custom message for the given element name and validation method
      customMessage: function(name,method) {
        var m = this.settings.messages[name];
        return m && (m.constructor === String ? m : m[method]);
      },

      // return the first defined argument, allowing empty strings
      findDefined: function() {
        for(var i = 0;i < arguments.length;i++) {
          if(arguments[i] !== undefined) {
            return arguments[i];
          }
        }
        return undefined;
      },

      defaultMessage: function(element,method) {
        return this.findDefined(
          this.customMessage(element.name,method),
          this.customDataMessage(element,method),
          // title is never undefined, so handle empty string as undefined
          !this.settings.ignoreTitle && element.title || undefined,
          $.validator.messages[method],
          "<strong>Warning: No message defined for " + element.name + "</strong>"
        );
      },

      formatAndAdd: function(element,rule) {
        var message = this.defaultMessage(element,rule.method),
          theregex = /\$?\{(\d+)\}/g;
        if(typeof message === "function") {
          message = message.call(this,rule.parameters,element);
        } else if(theregex.test(message)) {
          message = $.validator.format(message.replace(theregex,"{$1}"),rule.parameters);
        }
        this.errorList.push({
          message: message,
          element: element,
          method: rule.method
        });

        this.errorMap[element.name] = message;
        this.submitted[element.name] = message;
      },

      addWrapper: function(toToggle) {
        if(this.settings.wrapper) {
          toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
        }
        return toToggle;
      },

      defaultShowErrors: function() {
        var i,elements,error;
        for(i = 0;this.errorList[i];i++) {
          error = this.errorList[i];
          if(this.settings.highlight) {
            this.settings.highlight.call(this,error.element,this.settings.errorClass,this.settings.validClass);
          }
          this.showLabel(error.element,error.message);
        }
        if(this.errorList.length) {
          this.toShow = this.toShow.add(this.containers);
        }
        if(this.settings.success) {
          for(i = 0;this.successList[i];i++) {
            this.showLabel(this.successList[i]);
          }
        }
        if(this.settings.unhighlight) {
          for(i = 0,elements = this.validElements() ;elements[i];i++) {
            this.settings.unhighlight.call(this,elements[i],this.settings.errorClass,this.settings.validClass);
          }
        }
        this.toHide = this.toHide.not(this.toShow);
        this.hideErrors();
        this.addWrapper(this.toShow).show();
      },

      validElements: function() {
        return this.currentElements.not(this.invalidElements());
      },

      invalidElements: function() {
        return $(this.errorList).map(function() {
          return this.element;
        });
      },

      showLabel: function(element,message) {
        var place,group,errorID,
          error = this.errorsFor(element),
          elementID = this.idOrName(element),
          describedBy = $(element).attr("aria-describedby");
        if(error.length) {
          // refresh error/success class
          error.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
          // replace message on existing label
          error.html(message);
        } else {
          // create error element
          error = $("<" + this.settings.errorElement + ">")
            .attr("id",elementID + "-error")
            .addClass(this.settings.errorClass)
            .html(message || "");

          // Maintain reference to the element to be placed into the DOM
          place = error;
          if(this.settings.wrapper) {
            // make sure the element is visible, even in IE
            // actually showing the wrapped element is handled elsewhere
            place = error.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
          }
          if(this.labelContainer.length) {
            this.labelContainer.append(place);
          } else if(this.settings.errorPlacement) {
            this.settings.errorPlacement(place,$(element));
          } else {
            place.insertAfter(element);
          }

          // Link error back to the element
          if(error.is("label")) {
            // If the error is a label, then associate using 'for'
            error.attr("for",elementID);
          } else if(error.parents("label[for='" + elementID + "']").length === 0) {
            // If the element is not a child of an associated label, then it's necessary
            // to explicitly apply aria-describedby

            errorID = error.attr("id").replace(/(:|\.|\[|\]|\$)/g,"\\$1");
            // Respect existing non-error aria-describedby
            if(!describedBy) {
              describedBy = errorID;
            } else if(!describedBy.match(new RegExp("\\b" + errorID + "\\b"))) {
              // Add to end of list if not already present
              describedBy += " " + errorID;
            }
            $(element).attr("aria-describedby",describedBy);

            // If this element is grouped, then assign to all elements in the same group
            group = this.groups[element.name];
            if(group) {
              $.each(this.groups,function(name,testgroup) {
                if(testgroup === group) {
                  $("[name='" + name + "']",this.currentForm)
                    .attr("aria-describedby",error.attr("id"));
                }
              });
            }
          }
        }
        if(!message && this.settings.success) {
          error.text("");
          if(typeof this.settings.success === "string") {
            error.addClass(this.settings.success);
          } else {
            this.settings.success(error,element);
          }
        }
        this.toShow = this.toShow.add(error);
      },

      errorsFor: function(element) {
        var name = this.idOrName(element),
          describer = $(element).attr("aria-describedby"),
          selector = "label[for='" + name + "'], label[for='" + name + "'] *";

        // aria-describedby should directly reference the error element
        if(describer) {
          selector = selector + ", #" + describer.replace(/\s+/g,", #");
        }
        return this
          .errors()
          .filter(selector);
      },

      idOrName: function(element) {
        return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
      },

      validationTargetFor: function(element) {

        // If radio/checkbox, validate first element in group instead
        if(this.checkable(element)) {
          element = this.findByName(element.name);
        }

        // Always apply ignore filter
        return $(element).not(this.settings.ignore)[0];
      },

      checkable: function(element) {
        return (/radio|checkbox/i).test(element.type);
      },

      findByName: function(name) {
        return $(this.currentForm).find("[name='" + name + "']");
      },

      getLength: function(value,element) {
        switch(element.nodeName.toLowerCase()) {
          case "select":
            return $("option:selected",element).length;
          case "input":
            if(this.checkable(element)) {
              return this.findByName(element.name).filter(":checked").length;
            }
        }
        return value.length;
      },

      depend: function(param,element) {
        return this.dependTypes[typeof param] ? this.dependTypes[typeof param](param,element) : true;
      },

      dependTypes: {
        "boolean": function(param) {
          return param;
        },
        "string": function(param,element) {
          return !!$(param,element.form).length;
        },
        "function": function(param,element) {
          return param(element);
        }
      },

      optional: function(element) {
        var val = this.elementValue(element);
        return !$.validator.methods.required.call(this,val,element) && "dependency-mismatch";
      },

      startRequest: function(element) {
        if(!this.pending[element.name]) {
          this.pendingRequest++;
          this.pending[element.name] = true;
        }
      },

      stopRequest: function(element,valid) {
        this.pendingRequest--;
        // sometimes synchronization fails, make sure pendingRequest is never < 0
        if(this.pendingRequest < 0) {
          this.pendingRequest = 0;
        }
        delete this.pending[element.name];
        if(valid && this.pendingRequest === 0 && this.formSubmitted && this.form()) {
          $(this.currentForm).submit();
          this.formSubmitted = false;
        } else if(!valid && this.pendingRequest === 0 && this.formSubmitted) {
          $(this.currentForm).triggerHandler("invalid-form",[this]);
          this.formSubmitted = false;
        }
      },

      previousValue: function(element) {
        return $.data(element,"previousValue") || $.data(element,"previousValue",{
          old: null,
          valid: true,
          message: this.defaultMessage(element,"remote")
        });
      },

      // cleans up all forms and elements, removes validator-specific events
      destroy: function() {
        this.resetForm();

        $(this.currentForm)
          .off(".validate")
          .removeData("validator");
      }

    },

    classRuleSettings: {
      required: { required: true },
      email: { email: true },
      url: { url: true },
      date: { date: true },
      dateISO: { dateISO: true },
      number: { number: true },
      digits: { digits: true },
      creditcard: { creditcard: true }
    },

    addClassRules: function(className,rules) {
      if(className.constructor === String) {
        this.classRuleSettings[className] = rules;
      } else {
        $.extend(this.classRuleSettings,className);
      }
    },

    classRules: function(element) {
      var rules = {},
        classes = $(element).attr("class");

      if(classes) {
        $.each(classes.split(" "),function() {
          if(this in $.validator.classRuleSettings) {
            $.extend(rules,$.validator.classRuleSettings[this]);
          }
        });
      }
      return rules;
    },

    normalizeAttributeRule: function(rules,type,method,value) {

      // convert the value to a number for number inputs, and for text for backwards compability
      // allows type="date" and others to be compared as strings
      if(/min|max/.test(method) && (type === null || /number|range|text/.test(type))) {
        value = Number(value);

        // Support Opera Mini, which returns NaN for undefined minlength
        if(isNaN(value)) {
          value = undefined;
        }
      }

      if(value || value === 0) {
        rules[method] = value;
      } else if(type === method && type !== "range") {

        // exception: the jquery validate 'range' method
        // does not test for the html5 'range' type
        rules[method] = true;
      }
    },

    attributeRules: function(element) {
      var rules = {},
        $element = $(element),
        type = element.getAttribute("type"),
        method,value;

      for(method in $.validator.methods) {

        // support for <input required> in both html5 and older browsers
        if(method === "required") {
          value = element.getAttribute(method);

          // Some browsers return an empty string for the required attribute
          // and non-HTML5 browsers might have required="" markup
          if(value === "") {
            value = true;
          }

          // force non-HTML5 browsers to return bool
          value = !!value;
        } else {
          value = $element.attr(method);
        }

        this.normalizeAttributeRule(rules,type,method,value);
      }

      // maxlength may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
      if(rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
        delete rules.maxlength;
      }

      return rules;
    },

    dataRules: function(element) {
      var rules = {},
        $element = $(element),
        type = element.getAttribute("type"),
        method,value;

      for(method in $.validator.methods) {
        value = $element.data("rule" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase());
        this.normalizeAttributeRule(rules,type,method,value);
      }
      return rules;
    },

    staticRules: function(element) {
      var rules = {},
        validator = $.data(element.form,"validator");

      if(validator.settings.rules) {
        rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
      }
      return rules;
    },

    normalizeRules: function(rules,element) {
      // handle dependency check
      $.each(rules,function(prop,val) {
        // ignore rule when param is explicitly false, eg. required:false
        if(val === false) {
          delete rules[prop];
          return;
        }
        if(val.param || val.depends) {
          var keepRule = true;
          switch(typeof val.depends) {
            case "string":
              keepRule = !!$(val.depends,element.form).length;
              break;
            case "function":
              keepRule = val.depends.call(element,element);
              break;
          }
          if(keepRule) {
            rules[prop] = val.param !== undefined ? val.param : true;
          } else {
            delete rules[prop];
          }
        }
      });

      // evaluate parameters
      $.each(rules,function(rule,parameter) {
        rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
      });

      // clean number parameters
      $.each(["minlength","maxlength"],function() {
        if(rules[this]) {
          rules[this] = Number(rules[this]);
        }
      });
      $.each(["rangelength","range"],function() {
        var parts;
        if(rules[this]) {
          if($.isArray(rules[this])) {
            rules[this] = [Number(rules[this][0]),Number(rules[this][1])];
          } else if(typeof rules[this] === "string") {
            parts = rules[this].replace(/[\[\]]/g,"").split(/[\s,]+/);
            rules[this] = [Number(parts[0]),Number(parts[1])];
          }
        }
      });

      if($.validator.autoCreateRanges) {
        // auto-create ranges
        if(rules.min != null && rules.max != null) {
          rules.range = [rules.min,rules.max];
          delete rules.min;
          delete rules.max;
        }
        if(rules.minlength != null && rules.maxlength != null) {
          rules.rangelength = [rules.minlength,rules.maxlength];
          delete rules.minlength;
          delete rules.maxlength;
        }
      }

      return rules;
    },

    // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
    normalizeRule: function(data) {
      if(typeof data === "string") {
        var transformed = {};
        $.each(data.split(/\s/),function() {
          transformed[this] = true;
        });
        data = transformed;
      }
      return data;
    },

    // http://jqueryvalidation.org/jQuery.validator.addMethod/
    addMethod: function(name,method,message) {
      $.validator.methods[name] = method;
      $.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
      if(method.length < 3) {
        $.validator.addClassRules(name,$.validator.normalizeRule(name));
      }
    },

    methods: {

      // http://jqueryvalidation.org/required-method/
      required: function(value,element,param) {
        // check if dependency is met
        if(!this.depend(param,element)) {
          return "dependency-mismatch";
        }
        if(element.nodeName.toLowerCase() === "select") {
          // could be an array for select-multiple or a string, both are fine this way
          var val = $(element).val();
          return val && val.length > 0;
        }
        if(this.checkable(element)) {
          return this.getLength(value,element) > 0;
        }
        return value.length > 0;
      },

      // http://jqueryvalidation.org/email-method/
      email: function(value,element) {
        // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
        // Retrieved 2014-01-14
        // If you have a problem with this implementation, report a bug against the above spec
        // Or use custom methods to implement your own email validation
        return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
      },

      // http://jqueryvalidation.org/url-method/
      url: function(value,element) {

        // Copyright (c) 2010-2013 Diego Perini, MIT licensed
        // https://gist.github.com/dperini/729294
        // see also https://mathiasbynens.be/demo/url-regex
        // modified to allow protocol-relative URLs
        return this.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
      },

      // http://jqueryvalidation.org/date-method/
      date: function(value,element) {
        return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
      },

      // http://jqueryvalidation.org/dateISO-method/
      dateISO: function(value,element) {
        return this.optional(element) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value);
      },

      // http://jqueryvalidation.org/number-method/
      number: function(value,element) {
        return this.optional(element) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
      },

      // http://jqueryvalidation.org/digits-method/
      digits: function(value,element) {
        return this.optional(element) || /^\d+$/.test(value);
      },

      // http://jqueryvalidation.org/creditcard-method/
      // based on http://en.wikipedia.org/wiki/Luhn_algorithm
      creditcard: function(value,element) {
        if(this.optional(element)) {
          return "dependency-mismatch";
        }
        // accept only spaces, digits and dashes
        if(/[^0-9 \-]+/.test(value)) {
          return false;
        }
        var nCheck = 0,
          nDigit = 0,
          bEven = false,
          n,cDigit;

        value = value.replace(/\D/g,"");

        // Basing min and max length on
        // http://developer.ean.com/general_info/Valid_Credit_Card_Types
        if(value.length < 13 || value.length > 19) {
          return false;
        }

        for(n = value.length - 1;n >= 0;n--) {
          cDigit = value.charAt(n);
          nDigit = parseInt(cDigit,10);
          if(bEven) {
            if((nDigit *= 2) > 9) {
              nDigit -= 9;
            }
          }
          nCheck += nDigit;
          bEven = !bEven;
        }

        return (nCheck % 10) === 0;
      },

      // http://jqueryvalidation.org/minlength-method/
      minlength: function(value,element,param) {
        var length = $.isArray(value) ? value.length : this.getLength(value,element);
        return this.optional(element) || length >= param;
      },

      // http://jqueryvalidation.org/maxlength-method/
      maxlength: function(value,element,param) {
        var length = $.isArray(value) ? value.length : this.getLength(value,element);
        return this.optional(element) || length <= param;
      },

      // http://jqueryvalidation.org/rangelength-method/
      rangelength: function(value,element,param) {
        var length = $.isArray(value) ? value.length : this.getLength(value,element);
        return this.optional(element) || (length >= param[0] && length <= param[1]);
      },

      // http://jqueryvalidation.org/min-method/
      min: function(value,element,param) {
        return this.optional(element) || value >= param;
      },

      // http://jqueryvalidation.org/max-method/
      max: function(value,element,param) {
        return this.optional(element) || value <= param;
      },

      // http://jqueryvalidation.org/range-method/
      range: function(value,element,param) {
        return this.optional(element) || (value >= param[0] && value <= param[1]);
      },

      // http://jqueryvalidation.org/equalTo-method/
      equalTo: function(value,element,param) {
        // bind to the blur event of the target in order to revalidate whenever the target field is updated
        // TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
        var target = $(param);
        if(this.settings.onfocusout) {
          target.off(".validate-equalTo").on("blur.validate-equalTo",function() {
            $(element).valid();
          });
        }
        return value === target.val();
      },

      // http://jqueryvalidation.org/remote-method/
      remote: function(value,element,param) {
        if(this.optional(element)) {
          return "dependency-mismatch";
        }

        var previous = this.previousValue(element),
          validator,data;

        if(!this.settings.messages[element.name]) {
          this.settings.messages[element.name] = {};
        }
        previous.originalMessage = this.settings.messages[element.name].remote;
        this.settings.messages[element.name].remote = previous.message;

        param = typeof param === "string" && { url: param } || param;

        if(previous.old === value) {
          return previous.valid;
        }

        previous.old = value;
        validator = this;
        this.startRequest(element);
        data = {};
        data[element.name] = value;
        $.ajax($.extend(true,{
          mode: "abort",
          port: "validate" + element.name,
          dataType: "json",
          data: data,
          context: validator.currentForm,
          success: function(response) {
            var valid = response === true || response === "true",
              errors,message,submitted;

            validator.settings.messages[element.name].remote = previous.originalMessage;
            if(valid) {
              submitted = validator.formSubmitted;
              validator.prepareElement(element);
              validator.formSubmitted = submitted;
              validator.successList.push(element);
              delete validator.invalid[element.name];
              validator.showErrors();
            } else {
              errors = {};
              message = response || validator.defaultMessage(element,"remote");
              errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
              validator.invalid[element.name] = true;
              validator.showErrors(errors);
            }
            previous.valid = valid;
            validator.stopRequest(element,valid);
          }
        },param));
        return "pending";
      }
    }

  });

  // ajax mode: abort
  // usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
  // if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

  var pendingRequests = {},
    ajax;
  // Use a prefilter if available (1.5+)
  if($.ajaxPrefilter) {
    $.ajaxPrefilter(function(settings,_,xhr) {
      var port = settings.port;
      if(settings.mode === "abort") {
        if(pendingRequests[port]) {
          pendingRequests[port].abort();
        }
        pendingRequests[port] = xhr;
      }
    });
  } else {
    // Proxy ajax
    ajax = $.ajax;
    $.ajax = function(settings) {
      var mode = ("mode" in settings ? settings : $.ajaxSettings).mode,
        port = ("port" in settings ? settings : $.ajaxSettings).port;
      if(mode === "abort") {
        if(pendingRequests[port]) {
          pendingRequests[port].abort();
        }
        pendingRequests[port] = ajax.apply(this,arguments);
        return pendingRequests[port];
      }
      return ajax.apply(this,arguments);
    };
  }

}));

//   Clicktap
//   -----------------------
//   Register Clicktap event to automatically choose to either click
//   or tap depending on device support.


var tapEvent = {
	movement: 0,
	isValid: function() {
		return this.movement < 4;
	}
};

$.fn.clickTap = function(elem, f, preventStart) {
	//$(this).on('touchstart',function() { });
	$(this).on('touchmove', elem, function() {
		// Keep track of the number of touchmove events fired
		// If more than 3, we will cancel our touch event
		tapEvent.movement++;
	});
	$(this).on('touchend click', elem, function(e) {
		if (!preventStart) { e.preventDefault(); }
		// if no touchend
		if (e.type == 'touchend') {
			if (tapEvent.isValid()) {
				f.apply(this, [e]);
				// prevent from firing subsequent click event
				e.preventDefault();
			}
			// reset tap movement
			tapEvent.movement = 0;
			return;
		}
		f.apply(this, [e]);
	});
};
/*
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #1 - September 4, 2014
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/
var docCookies = {
	getItem: function(sKey) {
		if (!sKey) { return null; }
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	},
	setItem: function(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
		console.log(vEnd);
		if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
		var sExpires = "";
		if (vEnd) {
			console.log(vEnd);
			switch (vEnd.constructor) {
				case Number:
					console.log('num');
					sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
					break;
				case String:
					console.log('hi');
					sExpires = "; expires=" + vEnd;
					debugger;
					break;
				case Date:
					sExpires = "; expires=" + vEnd.toUTCString();
					break;
			}
		}
		document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
		//console.log(encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : ""));
		return true;
	},
	removeItem: function(sKey, sPath, sDomain) {
		if (!this.hasItem(sKey)) { return false; }
		document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
		return true;
	},
	hasItem: function(sKey) {
		if (!sKey) { return false; }
		return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
	},
	keys: function() {
		var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
		for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
		return aKeys;
	}
};

function FormConstructor() {
    var $form,
        $fieldWrap,
        $fields,
        $submit,
        $page = $('.page'),

        // salesforce submit URL
        //sfid = "&oid=00D80000000KudK",
        //sfga = "&sfga=00D80000000KudK",
        salesForceEndpoint = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=00D80000000KudK&sfga=00D80000000KudK&',
        formId,
        s = {},
        leadAttributes = [
            'leadSource',
            'campaign',
            'referralPartner'
        ],
        _completionTimer,
        dt = new Date(),
        time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds(),
        date = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate(),
        dateTime = date + ' ' + time;

    this.submitInProgress = false;
    this.submissionPoints = 0;


    // --------------------------
    // Validation Methods
    // --------------------------
    function _initValidationRules() {
        // initialize form validation so we can add new rules
        $('form').validate();
        $fields.each(function (i) {
            var fieldName = $(this).attr('name');

            if (fieldName == "phone") {
                $(this).rules("add", {
                    minlength: 10,
                    messages: {
                        minlength: "Please enter a valid phone number with area code"
                    }
                });
            }
            if (fieldName == "email") {
                $(this).rules("add", {
                    email: true,
                    tldCheck: true,
                    messages: {
                        email: "Please enter a valid email address"
                    }
                });
            }
            $(this).rules("add", {
                required: true,
                messages: {
                    required: "This field is required"
                }
            });
        });

        // require email addresses to have both an @ symbol
        // and at least a 2 character top level domain
        $.validator.addMethod("tldCheck", function (value) {
            var string = value;
            var lastChar = string.length;
            var tldUrl = string.substring(string.indexOf('@'), lastChar);
            var domIndex = tldUrl.lastIndexOf('.') + 2;
            var tldCheck = tldUrl.charAt(domIndex);
            var atCheck = tldUrl.charAt(domIndex - 1);
            return tldCheck && atCheck != '@';
        }, "Please enter a valid email address");
    }

    function _allFieldsValid(isHuman) {
        var booValid = true;

        //If human test was completed and correct submit the form with field validation but skip bot detection!
        if (isHuman == "true") {

            // loop through required fields and set booValid to false if any of them are invalid
            $fields.each(function () {

                if (!$(this).valid()) {
                    booValid = false;
                }

                // check for test submissions
                if ($(this).val() && $(this).val().toUpperCase().indexOf('_TEST') > -1) {
                    s.leadType = 'ignore';
                }
            });
        }
        else if (isHuman == "false") {
            _displayErrorAndPreventSubmission('Invalid Submission', 'Form submission could not be processed. For immediate assistance please contact us by email or phone. <br /> <br /><strong>contact sales:</strong>  sales@certify.com  |  888-925-0510 <strong> <br /> contact support:</strong>  support@certify.com  |  888-925-0510');
            throw new Error('Invalid Submission');
        }

        if (isHuman == null) {
            // Detect if bots exist in Honey Pot and Character Detection dig out the human test
            if (_preventBotSubmissions()) {
                booValid = false;

                _disableSubmit();

                if (_humanTest()) {
                    booValid = true;

                    $fields.each(function () {

                        if (!$(this).valid()) {
                            booValid = false;
                        }

                        // check for test submissions
                        if ($(this).val() && $(this).val().toUpperCase().indexOf('_TEST') > -1) {
                            s.leadType = 'ignore';
                        }

                        return booValid;
                    });
                }
            }
            else {
                // loop through required fields and set booValid to false if any of them are invalid
                $fields.each(function () {

                    if (!$(this).valid()) {
                        booValid = false;
                    }

                    // check for test submissions
                    if ($(this).val() && $(this).val().toUpperCase().indexOf('_TEST') > -1) {
                        s.leadType = 'ignore';
                    }
                });
            }
        }

        return booValid;
    }

    function _addHoneyPotCaptcha() {
        var i = getRandomInt(0, $fields.length - 1);

        // A field hidden by JavaScript: honeypot field that only bots which enter data into hidden fields will fill out.
        var userDataHtml = '<div class="inputWrap userContent"><label for="userName">Username</label><input id="userName" class="userName" type="text" name="userName"></div>';

        // A field hidden by CSS: honeypot field that is populated to the users email address when the real email field is blurred.
        var emailHtml = '<div class="inputWrap userData"><label for="userAddress">User Address</label><input id="userAddress" class="userAddress" type="text" name="userAddress"></div>';

        // A field requiring a specific input: Using date/time as the value, it must not be changed by a bot or it will prevent Form from submitting
        var dateHtml = '<div class="inputWrap userData"><label for="userPhone">User Phone</label><input id="userPhone" class="userPhone" type="text" value="' + dateTime + '" name="userPhone"></div>';

        // A field requiring a blank input: Using a blank value, it must not be filled by a bot or it will prevent Form from submitting
        var blankHtml = '<div class="inputWrap userData"><label for="userComments">Comments</label><input id="userComments" class="userComments" type="text" value="" name="userPhone"></div>';

        if ($($('.inputWrap')[i]).length) {
            $($('.inputWrap')[i]).prepend(userDataHtml, emailHtml, dateHtml, blankHtml);

        } else {
            $($fields[i]).prepend(userDataHtml, emailHtml, dateHtml, blankHtml);
        }

        //Hiding fields above via jquery
        $('.userContent').hide();
    }

    function _humanTest() {
        var isHuman = false;
        var valueOne = Math.floor(Math.random() * 10);
        var valueTwo = Math.floor(Math.random() * 10);
        var operators = ['+', '-']  // An array of Operators
        var operator = operators[Math.round(Math.random() * (operators.length - 1))];  // Choose a random operator
        var humanTestHTML = "<hr><div class='human-test'><label class='intro'>Prove you are human</label><div class='human-test--inner'><h5 class='question'><span class='valOne'>" + valueOne + "</span><span class='operator'>" + operator + "</span><span class='valTwo'>" + valueTwo + "</span> =</span></span></h5><input class='answer' aria-required='true' type='text' /></div></div>";

        if (operator == '-') {
            result = valueOne - valueTwo;
        }
        else {
            result = valueOne + valueTwo;
        }

        $(humanTestHTML).insertBefore('.submit');

        $('.submit').addClass('human-test-button');
        $('.submit').attr('data-human', false);

        var humanTest = $('.human-test');
        var numOne = $('.valOne', humanTest);
        var numTwo = $('.valTwo', humanTest);
        var operatorHTML = $('.operator', humanTest);
        var humanTestResult = $('.answer', humanTest);
        var submitTest = $('.submit', humanTest);

        //Fill in human test with the random values
        $(numOne).html(valueOne);
        $(numTwo).html(valueTwo);
        $(operatorHTML).html(operator);

        //Push isHuman variable to data-human attribute (true/false) on submit button during keyup event.
        $(humanTestResult).on('keyup', function () {
            var answerValue = $(this).val();

            _enableSubmit();

            if (answerValue == result) {
                isHuman = true;
            }
            else {
                isHuman = false;
            }

            $('.submit').attr("data-human", isHuman);
        });
    }


    function _preventBotSubmissions() {
        var fields = $('input.formField');
        var char = '';
        var botDetected = false;

        //Step 1: Are any of the honeyPot fields filled out?
        if ($('.userName').val() !== '' || $('.userAddress').val() !== '' || $('.userPhone').val() !== dateTime || $('.userComments').val() !== '') {
            // check if honeypot field filled by bot
            s.leadType = 'ignore';

            _displayErrorAndPreventSubmission('Invalid Submission', 'Form submission could not be processed. For immediate assistance please contact us by email or phone. <br /> <br /><strong>contact sales:</strong>  sales@certify.com  |  888-925-0510 <strong> <br /> contact support:</strong>  support@certify.com  |  888-925-0510');
            throw new Error('Invalid Submission');
        }

        //Step 2: Go through each field inside of form for Foreign Character test
        $(fields).each(function () {
            var target = $(this).val();
            var d = false;

            //Check through each character in this field for foreign character (not part of alphabet)
            for (var i = 0; i < target.length; i++) {
                char = target.charAt(i);

                //Is this character a foreign character??
                d = /[\u3400-\u9FBF]/.test(char);

                //If true then set botDetected variable to true
                if (d == true) {
                    botDetected = true;
                }
            }
        });

        return botDetected;
    }

    function _formatPhoneNumberForSF() {
        if ($('input[name="phone"]').val()) {
            phoneNum = $('input[name="phone"]').val();
            phoneNum = phoneNum.replace(/\s+/g, '');
            phoneDigits = phoneNum.replace(/\D/g, '').length;
            if (phoneDigits > 10 && phoneNum.charAt(0)) {
                phoneNum = phoneNum.substr(1);
            }
            if (phoneNum.charAt(0) == '-') {
                phoneNum = phoneNum.substr(1);
            }
            $('input[name="phone"]').val(phoneNum);
        }
    }


    // --------------------------
    // Optional setting methods
    // --------------------------
    function _autoLoad() {
        setTimeout(function () {

            _showModal($form);
            //blur landing page content if selected
            if ($('.blur-wrap').length) {
                $('.blur-wrap').addClass('blur');
            }
        }, s.autoLoadDelay);
    }

    function _enableLinkedInAutofill() {
        $('form').attr('name', 'autoFillForm');
        var LI = document.createElement('script');
        LI.src = '//platform.linkedin.com/in.js';
        LI.type = 'text/javascript';
        LI.innerHTML = ' \n api_key: 7751qswuyhszau \n noAuth: true \n lang: en_us \n';
        $('head').append(LI);
        var LIdata = '<script ';
        LIdata += 'src="https://www.linkedin.com/autofill/js/autofill.js"';
        LIdata += 'type="text/javascript" async></script>';
        //LIdata += '<script type="IN/Form2" ';
        //LIdata += 'data-form= "' + formId + '"';
        //LIdata += 'data-field-firstname="first_name" ';
        //LIdata += 'data-field-lastname="last_name" ';
        //LIdata += 'data-field-phone="phone" ';
        //LIdata += 'data-field-company="company" ';
        //LIdata += 'data-field-state="state"';
        //LIdata += '></script>';
        $fieldWrap.prepend(LIdata);
        //$fieldWrap.prepend('<div style="position:relative;min-height:45px;"> <div class="linkedIn-button"><span class="IN-logo"></span><span class="title"><span class="title-text follow">AutoFill with <strong>LinkedIn</strong></span></span></div>' + LI + LIdata + '</div>');
    }

    function _initOptionalFeatures() {
        //find number of required submit locations
        if (s.salesForce) this.submissionPoints++;
        if (s.pardotUrl) this.submissionPoints++;

        if ($fieldWrap.find('.ac-select').length) {
            _initAutocomplete();
        }
        if (s.modal) {
            _activateModal();
        }
        if (s.enableLinkedInAutofill) {
            try {
                _enableLinkedInAutofill();
            } catch (error) {
                // do nothing, LinkedIn Autofill breaks in older browsers, notably IE8
                console.log(error);
            }
        }
    }

    function _initAutocomplete() {
        // add relevancy sorting to nodes with the "boost" attribute
        $('.ac-select.pristine').selectToAutocomplete({
            'relevancy-sorting-booster-attr': 'boost'
        });

        $('.ac-select').removeClass('pristine');


        // abort if autocomplete inputs have not been created
        if (!$fieldWrap.find('.ui-autocomplete-input').length) {
            s.autoComplete = false;
            return false;
        }

        // cache formfields and autoComplete fields
        var $ffCountry = $form.find('#country'),
            $ffState = $form.find('#state'),
            $international = $('#international'),
            $acState = $('#ac-state'),
            $acCountry = $('#ac-country'),
            $phone = $form.find('#phone');

        // Both country and state fields are required for autocomplete.
        // Otherwise validation will fail.
        if (!$acCountry.length || !$acState.length) {
            console.log('!$acCountry.length || !$acState.length');
            return;
        }

        // Apply autocomplete attribute for Country/State fields
        // This prevents autofill, specific inputs are required
        $('#ac-country').prop('autocomplete', 'new-password');
        $('#ac-state').prop('autocomplete', 'new-password');

        function validateStateFieldByType(type) {
            // check if selected option is the wrong type
            if (!$ffState.find('option:selected').hasClass(type)) {

                // deselect currently selected option for "state" field
                $ffState.find('option:selected')
                    .val('')
                    .removeAttr('selected');
                $acState
                    .val('')
                    .removeClass('valid')
                    .data().uiAutocomplete.term = null;
            }

            // if this function gets called, country is not international
            $acState.attr('disabled', false);
        }

        function isUSA() {
            var isUSA = false,
                $selectedOption = $('#country').find('option[selected="selected"]');

            // Now relies on what option was automatically chosen instead of what user types in field
            if ($selectedOption.attr('value') === 'United States of America (USA)') {
                isUSA = true;
            }

            return isUSA;
        }

        function isCanada() {
            var isCanada = false,
            $selectedOption = $('#country').find('option[selected="selected"]');

            // Now relies on what option was automatically chosen instead of what user types in field
            if ($selectedOption.attr('value') === 'Canada') {
                isCanada = true;
            }

            return isCanada;
        }

        function isInternational() {
            return $acCountry.val() && !isUSA() && !isCanada();
        }

        function disableStateField() {
            $international.attr('selected', true);
            $acState
                .val($international.text())
                .attr('disabled', true);
        }
        function enableStateField() {
            $international.attr('selected', false);
            $acState
                .val('')
                .attr('disabled', false)
                .data().uiAutocomplete.term = null;
        }

        // make sure only appropriate options available for state based on value of country
        function validateStateAgainstCountry() {

            // Find out if user filled in country or state field, then trigger their change function
            // This is so we can rely on autocomplete option instead of user's entered value (better matching)
            if ($(this).attr('id') === 'ac-country') {
                $ffCountry.trigger('change');
            }
            if ($(this).attr('id') === 'ac-state') {
                $ffState.trigger('change');
            }

            if (isUSA()) {
                validateStateFieldByType('state');
            } else if (isCanada()) {
                validateStateFieldByType('province');
            } else if (isInternational()) {
                // is international
                disableStateField();
            } else {
                enableStateField();
            }

            $('form').validate('#ac-state');
        }

        // when ac-country value is selected, validate currently selected state.
        $(document).on('autocompleteclose.form', '.ui-autocomplete-input', validateStateAgainstCountry);

    }


    // ----------------------------
    // Modal form methods
    // ----------------------------
    var _sizeModalTimer;

    function _activateModal(e) {
        // Add modal design elements

        if (isLegacyIE) {
            $fieldWrap.addClass('old-ie');
        }
        $fieldWrap.find('.inner').addClass('modal-inner');
        $('<div class="modal-bg"></div>').insertAfter($form);

        if (s.autoLoadDelay) {
            _autoLoad();
        } else {
            $fieldWrap.prepend('<a class="modal-close"></a>');
        }

        _sizeModal();
    }

    function _approveModal() {
        if ($('.blur-wrap').length) {
            $('.blur-wrap').removeClass('blur');
        }
        $form
            .addClass('modal-approved')
            .removeClass('modal-show');

        // Make sure page is reset to viewable state
        _responsiveFix();

        if (!s.completionUrl) {
            // ** register form fill with bizo for prospect filtering
            $('#bizo').find('img').attr('src', 'https://www.bizographics.com/collect/?fmt=gif&url=confirmation.certify.com&pid=6907');
        }

        if (s.leadSource) {
            this.creditLeadSource(s.leadSource);
        }

    }

    function _showModal($activeForm) {
        // if no active form specified just use $form
        if ($activeForm) {
            $activeForm.addClass('modal-show');
        } else {
            $form.addClass('modal-show');
        }

        _responsiveFix();
    }

    function _hideModal() {
        $('.modal-show').removeClass('modal-show');
    }

    function getFormHeight() {
        return $fieldWrap.find('.modal-inner').outerHeight();
    }

    function _sizeModal() {
        clearTimeout(_sizeModalTimer);
        // throttle timer so this doesn't jump all over the place on resize
        _sizeModalTimer = setTimeout(function () {
            $form.css({
                'height': getFormHeight()
            });
            _responsiveFix();
        }, 100);
    }

    function _responsiveFix() {
        var useScrollableForm = $(window).height() < getFormHeight() + 100;
        var formVisible = $form.hasClass('modal-show');

        var formResponsive = $('.page').hasClass('mobile-friendly');

        if (formVisible && useScrollableForm) {
            // This makes the form scrollable if the current window size is shorter than the form
            $('.page')
                .addClass('mobile-friendly')
                .css('height', getFormHeight() + 100);

            $(window).scrollTop(0);
            return;
        }


        if (formResponsive && (!useScrollableForm || !formVisible)) {
            // if form is currently responsive and either doesn't meet useScrollableForm conditions or is not visible
            // this returns the page to a viewable state after changing to mobile friendly mode.
            $('.page')
                .removeClass('mobile-friendly')
                .removeAttr('style');
        }
    }


    // Submission Methods
    // ******************
    function _enableSubmit() {
        $submit.removeAttr('disabled');
    }
    function _disableSubmit() {
        $submit.attr('disabled', 'disabled')
    }
    function _doGDPROptInCheck() {
        // Form submission must be disabled unless a user has consented to the 
        // GDPR agreement. Info here: https://www.eugdpr.org/
        if ($("#gdproptin").is(':checked')) {
            _enableSubmit();
        } else {
            _disableSubmit();
        }
    }
    function _submitDataToEndpoint(endpointUrl, data) {
        var that = this;
        var postDataLabel = 'postdata-' + Date.now();

        console.log('submit to ' + endpointUrl)
        Storage.session.set(postDataLabel, endpointUrl + data);

        // initiate an http request via setting the source of an img tag.
        $('<img style="position:absolute;left:-9999px;" />').insertBefore($('#Form1'))
            .attr('src', endpointUrl + data)
            .one('load error', function () {
                // submission was successful so remove from storage
                Storage.session.remove(postDataLabel);

                that.submissionPoints--;

                // form has successfully submitted to all endpoints
                if (that.submissionPoints < 1) {
                    window.clearTimeout(_completionTimer);
                    _doCompletionActions.call(that);
                }
            });
    }

    this.submitDataToEndpointDelayed = function (label, postDataUrl) {
        // if submission was aborted prior to completing on a previous page, 
        // save the submit data in session and try to submit it on the next page.
        console.log('submit to ' + label)
        console.log('with ' + postDataUrl)

        $('<img style="position:absolute;left:-9999px;" />').insertBefore($('#Form1'))
            .attr('src', postDataUrl)
            .one('load error', function () {
                console.log('submit success');
                // submission was successful so remove from storage
                Storage.session.remove(label);
            });
    }

    function _doCompletionActions() {
        this.submitInProgress = false;

        // Grant access to gated marketing resources
        _grantAccess();

        if (s.completionUrl) {
            this.redirect();
        }

        $form.off('.form');
    }

    function _submit() {
        var arrSubmissions = [];
        var that = this;
        s.success = true;
        // match this honeypot field to email address field for validation on the server.
        // this will help us flag forms being submitted by POST data.
        $('.userAddress').val($('.formField[name="email"]').val());

        if (s.preSubmitCallback) {
            try {
                s.preSubmitCallback();
            }
            catch (err) {
                // if callback fails report error 
                console.log(err);
                window.reportErrorToGA(err, 'Form - Error', 'Validate callback error');
            }
        }

        // format phone number for SF
        _formatPhoneNumberForSF();

        // submission can be aborted by using this.update in the validation callback
        if (s.abortSubmission) {
            // unbind google analytics events
            $form.off('.track');
            return;
        }

        // add optional fields to $fields prior to submission (but post validation)
        var $allFields = $fields.add($form.find('textarea'))
            .add($form.find('input'))
            .add($form.find('select'));

        // this is necessary because in some cases, pardot and salesforce look for
        // different field names for the same piece of data.
        $allFields.each(function () {
            if ($(this).data().fieldmatch) {
                $(this).val($('[name=' + $(this).data().fieldmatch + ']').val());
            }
        });

        var fieldData = $allFields.serialize() + this.getLeadData();

        if (s.pardotUrl) {
            s.pardotUrl = s.pardotUrl[s.pardotUrl.length - 1] == '?' ? s.pardotUrl : s.pardotUrl + '?';
            _submitDataToEndpoint(s.pardotUrl, fieldData);
        }

        if (s.salesForce) {
            _submitDataToEndpoint(salesForceEndpoint, fieldData);
        }

        if (s.completionUrl) {
            // append loading animation while form processes
            _appendLoadingAnimation($fieldWrap.find('.inner'));
        }

        // Timeout submission and do completion actions after 3 seconds.
        // If the page redirects, we will attempt to submit on the completion page.
        // Otherwise, the submission will continue to process while the user remains on the page
        _completionTimer = setTimeout(function () {
            _doCompletionActions.call(that);
        }, s.completionTimeout);

        if (s.modal) {
            _approveModal();
        }
    };

    function _grantAccess() {
        // grant user access to gated marketing resources
        if (URLinfo.path == 'videodemos.aspx' || URLinfo.path == 'whitepapersandmore.aspx' || URLinfo.path == 'requestinformation.aspx' || URLinfo.path == 'requestdemo.aspx' || URLinfo.path == 'contactus.aspx') {
            Storage.local.set('submittedDemoForm', true);
        }
    }

    function _displayError(errorMessage) {
        $('<div class="alert alert--error">' + errorMessage + '</div>').insertBefore($fieldWrap);
    }

    function _displayErrorAndPreventSubmission(error, msg) {
        window.reportErrorToGA(error, 'Form - Error', error);
        var errorMessage = msg || 'An unexpected error has occurred, please try again later. For immediate assistance please contact us by email or phone. <br /> <br /><strong>contact sales:</strong>  sales@certify.com  |  888-925-0510 <strong> <br /> contact support:</strong>  support@certify.com  |  888-925-0510';


        $form.off('.submitForm');

        $(document).on('click submit', '.submit', function (e) {
            e.preventDefault();
        });

        $(document).on('click.err submit.err', '.submit', function (e) {
            e.preventDefault();
            // send error report and generate error message on submit
            $('<div class="alert alert--error">' + errorMessage + '</div>').insertBefore($submit);

            if (s.modal) _sizeModal();

            $(this).attr('disabled', 'disabled');

            // prevent from repeating error submit actions
            $(document).off('.err');
        });
    }


    // Redirect Methods
    // ***********************
    this.redirect = function (readyToSubmit, cancelModalClose) {
        // readyToSubmit param is deprecated. 
        // Leaving it in for now to preserve position of cancelModalClose param - MP 08/14/2018

        _redirectToCompletionUrl();
    };

    function _redirectToCompletionUrl(url) {
        var prefix = '';
        s.completionUrl = url || s.completionUrl;

        if (s.leadSource) {
            // if a leadsource is set, make sure it is credited upon submission
            prefix = s.completionUrl.indexOf('?') > -1 ? '&' : '?';
            s.completionUrl += prefix + 'lc=' + s.leadSource;
        }

        window.location.href = s.completionUrl;
    }

    function _appendLoadingAnimation($elem) {
        if (!$('.submit-progress-indicator').length) {
            // Append loading animation while redirect processes
            // if one has not already been added
            $elem.append('<div class="submit-progress-indicator loader"></div>');
        }
    }


    // Lead Data assignment/manipulation methods
    // ******************************************

    this.getLeadData = function () {
        var optionalData = '&submitPage=' + URLinfo.href.replace(/#/g, "");
        if (s.campaign) {
            optionalData = optionalData + '&Campaign_Referral__c=' + encodeURIComponent(s.campaign);
        }
        if (s.leadSource) {
            optionalData = optionalData + '&LeadSource=' + encodeURIComponent(s.leadSource);
            optionalData = optionalData + '&lead_source=' + encodeURIComponent(s.leadSource);
        }
        if (s.referralPartner) {
            optionalData = optionalData + '&Referral_Partner__c=' + encodeURIComponent(s.referralPartner);
            if (!s.leadType) {
                optionalData = optionalData + '&Type_of_Lead__c= \'Partner Referral\' ';
            }
        }
        if (s.leadType) {
            optionalData = optionalData + '&Type_of_Lead__c=' + encodeURIComponent(s.leadType);
        }
        if (s.resourceRequested) {
            optionalData = optionalData + '&Resource_Requested__c=' + encodeURIComponent(s.resourceRequested);
        }
        if (s.resourceType) {
            optionalData = optionalData + '&resource_type__c=' + encodeURIComponent(s.resourceType);
        }
        if (s.productRequested) {
            optionalData = optionalData + '&Product_Requested__c=' + encodeURIComponent(s.productRequested);
        }

        return optionalData;
    };

    this.creditLeadSource = function (source) {
        if (!source) return;
        sourceToCredit = source.toLowerCase();

        console.log('crediting', sourceToCredit);

        // Define crediting methods to be used in switch block below
        function creditCapterra() {
            var capterra_vkey = '4a0ee62ad0eb379950d641740694ef4a',
                capterra_vid = '2065655',
                capterra_prefix = (('https:' == document.location.protocol) ? 'https://ct.capterra.com' : 'http://ct.capterra.com');
            (function () {
                var ct = document.createElement('script'); ct.type = 'text/javascript'; ct.async = true;
                ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ct, s);
            })();
        }

        switch (sourceToCredit) {
            case 'capterra':
                creditCapterra();
                break;
            default:
                // window.reportErrorToGA(sourceToCredit, 'Lead Credit Error', 'No credit method exists for this source');
                break;
        }

        Storage.local.remove('sourceToCredit');

    };


    // Initialization & configuration
    // *******************************
    function _getSettings(settings, activateCallback, preSubmitCallback) {
        var formSettings = settings || {};
        var sessionData = _getSessionData();

        var defaults = {
            activateCallback: activateCallback || false,
            preSubmitCallback: preSubmitCallback || false,
            completionTimeout: 3000,

            // ** Dom configuration options
            containerElem: false, // if false this will default to $('#certifyForm'). OK to leave false if only one form on the page

            // ** submit options
            salesForce: true,
            pardotUrl: urlParams.pardotUrl || 'https://emburse.certify.com/index.php/leadCapture/save',
            completionUrl: urlParams.completionUrl,
            // ** modal form options
            modal: false,
            modalActivator: $('.gatedContent').length > 0 ? '.gatedContent' : false,
            activatorEvent: 'click',
            // ** pardot campaign data options
            leadType: urlParams.leadType,
            resourceRequested: urlParams.resourceRequested,
            resourceType: urlParams.resourceType,
            campaign: urlParams.campaign || sessionData.campaign,
            leadSource: urlParams.leadSource || sessionData.leadSource,
            referralPartner: urlParams.referralPartner || sessionData.referralPartner,
            productRequested: urlParams.productRequested || sessionData.productRequested,

            // ** Data entry options
            enableLinkedInAutofill: urlParams.autofill || false,

            // ** completion state indicators
            success: false,
            started: false,
            numTimesSubmitted: 0,
            numSubmitLocations: 0,
            abortSubmission: false
        };


        // conditionally set autoloadDelay
        defaults.autoLoadDelay = formSettings.modalActivator || $('.gatedContent').length > 0 ? false : 1000; // ** accepts a number greater than 0

        return $.extend(defaults, formSettings);
    }

    function _getSessionData() {
        var data = {};

        // if no local storaage support  return an empty object
        if (!localStorageSupported) return data;

        // define usable portions of data.
        leadAttributes.forEach(function (key, i) {
            if (key in sessionStorage) {
                data[key] = sessionStorage[key];
            }
        })

        return data;
    };

    function _storeSessionData() {
        // Store form URL params if any are present
        if ($.isEmptyObject(urlParams)) return;

        if (!localStorageSupported) return;

        $.each(leadAttributes, function (index, key) {
            if (key in urlParams) {
                sessionStorage.setItem(key, urlParams[key]);
            }
        });
    }

    function _bindGATracking() {
        // track landing on page
        function startTrack() {
            s.started = true;
            // ** only track start once per form
            $fieldWrap.off('.start');
        }

        $form.on('focus.start keydown.start', '.formField', startTrack);

        $(window).on('beforeunload.track', function () {
            var category = 'Form - ' + s.leadType,
                conversionAction = 'Conversion';

            if (s.leadType == 'ignore') {
                conversionAction = 'ignore -' + conversionAction;
            }

            gaEvent(category, 'Land', URLinfo.path);

            if (s.started) {
                gaEvent(category, 'Start', URLinfo.path);
            }

            if (s.started && !s.success) {
                var percentComplete = Math.round(($fieldWrap.find('[aria-invalid=false]').length / $fields.length) * 100) / 100;
                gaEvent(category, 'Abandon', URLinfo.path, percentComplete);
            }
            if (s.success) {
                gaEvent(category, conversionAction, URLinfo.path);
            }
        });
    };

    function _bindFormEvents() {
        var that = this;
        // prevent empty values from appearing valid after a user has entered text
        $form.on('blur.form', '.formField', function () {
            if ($(this).val() === '') {
                $(this).removeClass('valid');
            }

            $('form').validate($(this));
        });

        if (s.autocomplete) {
            // prevent scrolling through autocomplete options, only show the few most relevant
            $('.ui-autocomplete').on('scroll.form', function () {
                $(this).scrollTop(0);
            });
        }

        if (s.modal) {
            $form.on('click.form', '.modal-close', _hideModal);

            $(window).on('resize', _sizeModal);

            $(function () {
                $form.on('blur.form keyup.form', '.formField', function () {
                    // have to do this because adding/removing error labels
                    // changes the height of the form container.
                    _sizeModal.call(that);
                });
            });

            if (!s.autoLoadDelay) {
                $(document).on(s.activatorEvent + '.form', s.modalActivator, function () {
                    _showModal.call(that, $('#' + $(this).data().formId));
                });
                $('.modal-bg').on('click', _hideModal);
            }
        }

        $form.on('submit.default click.default', '.submit', function (e) {
            e.preventDefault();

            if (s.modal) {
                _sizeModal.call(that);
            }
        });

        // submit behavior
        $form.on('submit.submitForm click.submitForm', '.submit', function (e) {
            //Has the user already completed the human test?
            if ($(this).hasClass('human-test-button')) {
                var isHuman = $(this).attr('data-human');
            }
            else {
                var isHuman = null;
            }

            // if submission in process stop here.
            if (that.submitInProgress) {
                return;
            }

            that.submitInProgress = true;

            // don't allow more than 20 attempts to submit.
            s.numSubs = typeof s.numSubs == 'undefined' ? 1 : s.numSubs + 1;

            if (s.numSubs > 20) {
                throw new Error('infinite loop');
            }

            // attempt validation + submit           
            try {
                if (_allFieldsValid(isHuman)) {
                    _submit.call(that)
                } else {
                    that.submitInProgress = false;
                }
            } catch (err) {
                window.reportErrorToGA(err, 'Form - Error', 'Validation error');
                that.submitInProgress = false;
            }

        });

        var $acCountry = $('#ac-country');
        var $country = $form.find('#country');
        var $acState = $form.find('#ac-state');
        var $state = $form.find('#state');
        var $phone = $form.find('#phone');

        // if country select element and phone field exist
        if ($country.length && $phone.length) {
  
            $country.on('change', function () {

                // if country input field has value: locate/apply DialCode 
                if ($('#ac-country').val().length !== 0) {

                    //Target selected option value
                    var $selectOption = $acCountry.val();
                    var $selected = $country.find('option').filter(function () { return $(this).html() == $selectOption; })
 
                    //Add 'selected' attribute to option that was selected, (used in validateStateAgainstCountry function)
                    $selected.attr('selected', 'selected');
                    $country.val($selectOption);

                    //Grab dialCode for selected Country
                    var dialCode = locateDialCode($selectOption);

                }
                // country field is empty: remove state field's value, add placeholder, remove floating label, and remove dialCode from phone field
                else {
                    $country.val('');
                    $('#ac-state').val('');
                    $('#ac-state').attr('placeholder', 'State/Province');
                }

                applyDialCode(dialCode);

            });

            // When country select element option is selected
            $state.on('change', function () {

                // if state input field is empty then remove value, add placeholder, and remove floating label
                if ($('#ac-state').val().length === 0) {

                    $state.val('');
                    $('#ac-state').val('');
                    $('#ac-state').attr('placeholder', 'State/Province');
                }
            });
        }

        function applyDialCode(dialCode) {
            // Check to see if we already have a dialCode stored as attribute
            var dataDialCode = $phone.attr('data-prefix');

            if (dialCode) {

                // If dialCode already exists in phone field, remove and replace with new dialCode
                if (dataDialCode) {

                    $phone.val(function (index, val) {
                        return val.replace(dataDialCode, dialCode).trim();
                    });

                    // Add new dialCode to data-prefix attribute
                    $phone.attr('data-prefix', dialCode);
                }
                // If dialCode doesn't already exist, add new dialCode and store it as data attribute
                else {
                    // add cc prefix to anything user has already entered for home number
                    var val = dialCode + ' ' + $phone.val() + ' ';
                    $phone.val('').val(val);
                    $phone.attr('data-prefix', dialCode);
                }
            }
            //If no dialCode was found then remove prefix from #phone field
            else {
                dialCode = '';
                var $phoneLabel = $phone.parent('.inputWrap');

                $phone.val(function (index, val) {
                    return val.replace(dataDialCode, dialCode).trim();
                });

                // Add attribute to keep log of previous dialCode to know what to switch out
                $phone.attr('data-prefix', dialCode);

                //If phone field is empty, remove floating label
                if ($phone.val().length == 0 && $phoneLabel.length > 0) {
                    //$phoneLabel.removeClass('has-floating-label', 'animate', 'isActive');
                    $phone.attr('placeholder', 'Business Phone');
                }
            }
        };

        function locateDialCode(countryName) {
            var prefix;
            var prefixAttr = $phone.attr('data-prefix');
            var country;

            country = countrycodes.filter(function (obj) {
                return obj.name == countryName
            });

            country.find(function (e) {
                prefix = e.dial_code;
            });

            //Caused an undefined bug, and we already were able to get dial_code
            //prefix = country ? country.dial_code : '';

            return prefix;
        };

        // enable/disable form based on whether GDPR opt-in has been checked
        $('#gdproptin').on('change', function () {
            _doGDPROptInCheck();
        });

        // bizible tracker binding for forms
        $submit.on('click', function () {
            var email = $form.find("input[name='email']").val()

            window['Bizible'] = window['Bizible'] || { _queue: [], Push: function (o, p) { this._queue.push({ type: o, data: p }); } };
            Bizible.Push('User', {
                eMail: email,   // required
            });
        });

    }

    this.init = function (settings, activateCallback, preSubmitCallback) {
		/*
		Settings {Object}:
		init accepts a settings object which is merged with defaults
		when the function is called. All defaults can be overwritten by passing
		in the appropriate key/value pair to the settings object
		-----------------------------------------------------------------------
		*/
        try {

            _storeSessionData();

            // configure form settings
            s = _getSettings.call(this, settings, activateCallback, preSubmitCallback)

            formId = 'form' + Date.now();

            $fieldWrap = s.containerElem || $('#certifyForm');
            $fieldWrap.wrapInner('<div class="inner"></div>');

            // wrap our fieldset in a <form> with a unique ID
            if (s.modal) {
                $fieldWrap.wrap('<div class="certify-form modal" id="' + formId + '"></div>');

                $fieldWrap
                    .removeClass('modal')
                    .addClass('modal-outer');
                $(s.modalActivator).data('formId', formId);
            } else {
                $fieldWrap.wrap('<div class="certify-form" id="' + formId + '"></div>');
            }

            // store a reference to the <form> we just created
            $form = $('#' + formId);


			/*
				wrap the fieldwrap in a form element so it can be submitted independantly if
				there is more than one form on the page. We have to do this here because
				otherwise the form will be stripped out of the HTML.
				--------------------------------------------------------------------------
			*/

            // do this to make sure that we only find the submit button attached to this form
            $submit = $form.find('.submit');

            // adding novalidate allows us to use our validation instead of default HTML5 validation
            $('form').attr({ 'novalidate': 'true' });


            // callback used to modify initialization under special circumstances
            if (s.activateCallback) {
                try {
                    s.activateCallback.call(this);
                }
                catch (error) {
                    // ** if callback fails report error to Pardot
                    window.reportErrorToGA(error, 'Form - Error', 'Activate callback error');
                }
            }

            // modify with any options selected in settings
            _initOptionalFeatures.call(this);

            // fields may be addedin initOptionalFeatures so $fields are cached here
            $fields = $fieldWrap.find('.formField');

            _addHoneyPotCaptcha.call(this);

            // setup field validation rules
            _initValidationRules.call(this);

            // bind form events to DOM elements
            _bindFormEvents.call(this);

            if (urlParams.isFormError) {
                _displayError('Form submission could not processed, please try again. For immediate assistance please contact us by email or phone. <br /> <br /><strong>contact sales:</strong>  sales@certify.com  |  888-925-0510 <strong> <br /> contact support:</strong>  support@certify.com  |  888-925-0510', true);
            }

            // initialize form analytics (Google Analytics)
            _bindGATracking.call(this);

            s.initialized = true;

            // check to see if the GDPR opt-in checkbox has been checked
            _doGDPROptInCheck();

        } catch (error) {
            // notify user that form is not working, provide support and sales info.
            console.log(error);
            if (error.message !== 'approved') {
                window.reportErrorToGA(error, 'Form - Error', 'Initialization Error');
            }
        }
    };

    // this function allows you to change a forms settings at any time after initialization
    this.update = function (settings) {
        s = $.extend(s, settings);
    };
}

// We use these to map country name to dial codes
window.countrycodes = [
    { "name": "Afghanistan", "dial_code": "+93", "code": "AF" },
    { "name": "Aland Islands", "dial_code": "+358", "code": "AX" },
    { "name": "Albania", "dial_code": "+355", "code": "AL" },
    { "name": "Algeria", "dial_code": "+213", "code": "DZ" },
    { "name": "AmericanSamoa", "dial_code": "+1684", "code": "AS" },
    { "name": "Andorra", "dial_code": "+376", "code": "AD" },
    { "name": "Angola", "dial_code": "+244", "code": "AO" },
    { "name": "Anguilla", "dial_code": "+1264", "code": "AI" },
    { "name": "Antarctica", "dial_code": "+672", "code": "AQ" },
    { "name": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG" },
    { "name": "Argentina", "dial_code": "+54", "code": "AR" },
    { "name": "Armenia", "dial_code": "+374", "code": "AM" },
    { "name": "Aruba", "dial_code": "+297", "code": "AW" },
    { "name": "Australia", "dial_code": "+61", "code": "AU" },
    { "name": "Austria", "dial_code": "+43", "code": "AT" },
    { "name": "Azerbaijan", "dial_code": "+994", "code": "AZ" },
    { "name": "Bahamas", "dial_code": "+1242", "code": "BS" },
    { "name": "Bahrain", "dial_code": "+973", "code": "BH" },
    { "name": "Bangladesh", "dial_code": "+880", "code": "BD" },
    { "name": "Barbados", "dial_code": "+1246", "code": "BB" },
    { "name": "Belarus", "dial_code": "+375", "code": "BY" },
    { "name": "Belgium", "dial_code": "+32", "code": "BE" },
    { "name": "Belize", "dial_code": "+501", "code": "BZ" },
    { "name": "Benin", "dial_code": "+229", "code": "BJ" },
    { "name": "Bermuda", "dial_code": "+1441", "code": "BM" },
    { "name": "Bhutan", "dial_code": "+975", "code": "BT" },
    { "name": "Bolivia, Plurinational State of bolivia", "dial_code": "+591", "code": "BO" },
    { "name": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA" },
    { "name": "Botswana", "dial_code": "+267", "code": "BW" },
    { "name": "Brazil", "dial_code": "+55", "code": "BR" },
    { "name": "British Indian Ocean Territory", "dial_code": "+246", "code": "IO" },
    { "name": "Brunei Darussalam", "dial_code": "+673", "code": "BN" },
    { "name": "Bulgaria", "dial_code": "+359", "code": "BG" },
    { "name": "Burkina Faso", "dial_code": "+226", "code": "BF" },
    { "name": "Burundi", "dial_code": "+257", "code": "BI" },
    { "name": "Cambodia", "dial_code": "+855", "code": "KH" },
    { "name": "Cameroon", "dial_code": "+237", "code": "CM" },
    { "name": "Canada", "dial_code": "+1", "code": "CA" },
    { "name": "Cape Verde", "dial_code": "+238", "code": "CV" },
    { "name": "Cayman Islands", "dial_code": "+ 345", "code": "KY" },
    { "name": "Central African Republic", "dial_code": "+236", "code": "CF" },
    { "name": "Chad", "dial_code": "+235", "code": "TD" },
    { "name": "Chile", "dial_code": "+56", "code": "CL" },
    { "name": "China", "dial_code": "+86", "code": "CN" },
    { "name": "Christmas Island", "dial_code": "+61", "code": "CX" },
    { "name": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC" },
    { "name": "Colombia", "dial_code": "+57", "code": "CO" },
    { "name": "Comoros", "dial_code": "+269", "code": "KM" },
    { "name": "Congo", "dial_code": "+242", "code": "CG" },
    { "name": "Congo, The Democratic Republic of the Congo", "dial_code": "+243", "code": "CD" },
    { "name": "Cook Islands", "dial_code": "+682", "code": "CK" },
    { "name": "Costa Rica", "dial_code": "+506", "code": "CR" },
    { "name": "Cote d'Ivoire", "dial_code": "+225", "code": "CI" },
    { "name": "Croatia", "dial_code": "+385", "code": "HR" },
    { "name": "Cuba", "dial_code": "+53", "code": "CU" },
    { "name": "Cyprus", "dial_code": "+357", "code": "CY" },
    { "name": "Czech Republic", "dial_code": "+420", "code": "CZ" },
    { "name": "Denmark", "dial_code": "+45", "code": "DK" },
    { "name": "Djibouti", "dial_code": "+253", "code": "DJ" },
    { "name": "Dominica", "dial_code": "+1767", "code": "DM" },
    { "name": "Dominican Republic", "dial_code": "+1849", "code": "DO" },
    { "name": "Ecuador", "dial_code": "+593", "code": "EC" },
    { "name": "Egypt", "dial_code": "+20", "code": "EG" },
    { "name": "El Salvador", "dial_code": "+503", "code": "SV" },
    { "name": "Equatorial Guinea", "dial_code": "+240", "code": "GQ" },
    { "name": "Eritrea", "dial_code": "+291", "code": "ER" },
    { "name": "Estonia", "dial_code": "+372", "code": "EE" },
    { "name": "Ethiopia", "dial_code": "+251", "code": "ET" },
    { "name": "Falkland Islands (Malvinas)", "dial_code": "+500", "code": "FK" },
    { "name": "Faroe Islands", "dial_code": "+298", "code": "FO" },
    { "name": "Fiji", "dial_code": "+679", "code": "FJ" },
    { "name": "Finland", "dial_code": "+358", "code": "FI" },
    { "name": "France", "dial_code": "+33", "code": "FR" },
    { "name": "French Guiana", "dial_code": "+594", "code": "GF" },
    { "name": "French Polynesia", "dial_code": "+689", "code": "PF" },
    { "name": "Gabon", "dial_code": "+241", "code": "GA" },
    { "name": "Gambia", "dial_code": "+220", "code": "GM" },
    { "name": "Georgia", "dial_code": "+995", "code": "GE" },
    { "name": "Germany", "dial_code": "+49", "code": "DE" },
    { "name": "Ghana", "dial_code": "+233", "code": "GH" },
    { "name": "Gibraltar", "dial_code": "+350", "code": "GI" },
    { "name": "Greece", "dial_code": "+30", "code": "GR" },
    { "name": "Greenland", "dial_code": "+299", "code": "GL" },
    { "name": "Grenada", "dial_code": "+1473", "code": "GD" },
    { "name": "Guadeloupe", "dial_code": "+590", "code": "GP" },
    { "name": "Guam", "dial_code": "+1671", "code": "GU" },
    { "name": "Guatemala", "dial_code": "+502", "code": "GT" },
    { "name": "Guernsey", "dial_code": "+44", "code": "GG" },
    { "name": "Guinea", "dial_code": "+224", "code": "GN" },
    { "name": "Guinea-Bissau", "dial_code": "+245", "code": "GW" },
    { "name": "Guyana", "dial_code": "+592", "code": "GY" },
    { "name": "Haiti", "dial_code": "+509", "code": "HT" },
    { "name": "Holy See (Vatican City State)", "dial_code": "+379", "code": "VA" },
    { "name": "Honduras", "dial_code": "+504", "code": "HN" },
    { "name": "Hong Kong", "dial_code": "+852", "code": "HK" },
    { "name": "Hungary", "dial_code": "+36", "code": "HU" },
    { "name": "Iceland", "dial_code": "+354", "code": "IS" },
    { "name": "India", "dial_code": "+91", "code": "IN" },
    { "name": "Indonesia", "dial_code": "+62", "code": "ID" },
    { "name": "Iran, Islamic Republic of Persian Gulf", "dial_code": "+98", "code": "IR" },
    { "name": "Iraq", "dial_code": "+964", "code": "IQ" },
    { "name": "Ireland", "dial_code": "+353", "code": "IE" },
    { "name": "Isle of Man", "dial_code": "+44", "code": "IM" },
    { "name": "Israel", "dial_code": "+972", "code": "IL" },
    { "name": "Italy", "dial_code": "+39", "code": "IT" },
    { "name": "Jamaica", "dial_code": "+1876", "code": "JM" },
    { "name": "Japan", "dial_code": "+81", "code": "JP" },
    { "name": "Jersey", "dial_code": "+44", "code": "JE" },
    { "name": "Jordan", "dial_code": "+962", "code": "JO" },
    { "name": "Kazakhstan", "dial_code": "+7", "code": "KZ" },
    { "name": "Kenya", "dial_code": "+254", "code": "KE" },
    { "name": "Kiribati", "dial_code": "+686", "code": "KI" },
    { "name": "Korea, Democratic People's Republic of Korea", "dial_code": "+850", "code": "KP" },
    { "name": "Korea, Republic of South Korea", "dial_code": "+82", "code": "KR" },
    { "name": "Kuwait", "dial_code": "+965", "code": "KW" },
    { "name": "Kyrgyzstan", "dial_code": "+996", "code": "KG" },
    { "name": "Laos", "dial_code": "+856", "code": "LA" },
    { "name": "Latvia", "dial_code": "+371", "code": "LV" },
    { "name": "Lebanon", "dial_code": "+961", "code": "LB" },
    { "name": "Lesotho", "dial_code": "+266", "code": "LS" },
    { "name": "Liberia", "dial_code": "+231", "code": "LR" },
    { "name": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY" },
    { "name": "Liechtenstein", "dial_code": "+423", "code": "LI" },
    { "name": "Lithuania", "dial_code": "+370", "code": "LT" },
    { "name": "Luxembourg", "dial_code": "+352", "code": "LU" },
    { "name": "Macao", "dial_code": "+853", "code": "MO" },
    { "name": "Macedonia", "dial_code": "+389", "code": "MK" },
    { "name": "Madagascar", "dial_code": "+261", "code": "MG" },
    { "name": "Malawi", "dial_code": "+265", "code": "MW" },
    { "name": "Malaysia", "dial_code": "+60", "code": "MY" },
    { "name": "Maldives", "dial_code": "+960", "code": "MV" },
    { "name": "Mali", "dial_code": "+223", "code": "ML" },
    { "name": "Malta", "dial_code": "+356", "code": "MT" },
    { "name": "Marshall Islands", "dial_code": "+692", "code": "MH" },
    { "name": "Martinique", "dial_code": "+596", "code": "MQ" },
    { "name": "Mauritania", "dial_code": "+222", "code": "MR" },
    { "name": "Mauritius", "dial_code": "+230", "code": "MU" },
    { "name": "Mayotte", "dial_code": "+262", "code": "YT" },
    { "name": "Mexico", "dial_code": "+52", "code": "MX" },
    { "name": "Micronesia, Federated States of Micronesia", "dial_code": "+691", "code": "FM" },
    { "name": "Moldova", "dial_code": "+373", "code": "MD" },
    { "name": "Monaco", "dial_code": "+377", "code": "MC" },
    { "name": "Mongolia", "dial_code": "+976", "code": "MN" },
    { "name": "Montenegro", "dial_code": "+382", "code": "ME" },
    { "name": "Montserrat", "dial_code": "+1664", "code": "MS" },
    { "name": "Morocco", "dial_code": "+212", "code": "MA" },
    { "name": "Mozambique", "dial_code": "+258", "code": "MZ" },
    { "name": "Myanmar", "dial_code": "+95", "code": "MM" },
    { "name": "Namibia", "dial_code": "+264", "code": "NA" },
    { "name": "Nauru", "dial_code": "+674", "code": "NR" },
    { "name": "Nepal", "dial_code": "+977", "code": "NP" },
    { "name": "Netherlands", "dial_code": "+31", "code": "NL" },
    { "name": "Netherlands Antilles", "dial_code": "+599", "code": "AN" },
    { "name": "New Caledonia", "dial_code": "+687", "code": "NC" },
    { "name": "New Zealand", "dial_code": "+64", "code": "NZ" },
    { "name": "Nicaragua", "dial_code": "+505", "code": "NI" },
    { "name": "Niger", "dial_code": "+227", "code": "NE" },
    { "name": "Nigeria", "dial_code": "+234", "code": "NG" },
    { "name": "Niue", "dial_code": "+683", "code": "NU" },
    { "name": "Norfolk Island", "dial_code": "+672", "code": "NF" },
    { "name": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP" },
    { "name": "Norway", "dial_code": "+47", "code": "NO" },
    { "name": "Oman", "dial_code": "+968", "code": "OM" },
    { "name": "Pakistan", "dial_code": "+92", "code": "PK" },
    { "name": "Palau", "dial_code": "+680", "code": "PW" },
    { "name": "Palestinian Territory, Occupied", "dial_code": "+970", "code": "PS" },
    { "name": "Panama", "dial_code": "+507", "code": "PA" },
    { "name": "Papua New Guinea", "dial_code": "+675", "code": "PG" },
    { "name": "Paraguay", "dial_code": "+595", "code": "PY" },
    { "name": "Peru", "dial_code": "+51", "code": "PE" },
    { "name": "Philippines", "dial_code": "+63", "code": "PH" },
    { "name": "Pitcairn", "dial_code": "+64", "code": "PN" },
    { "name": "Poland", "dial_code": "+48", "code": "PL" },
    { "name": "Portugal", "dial_code": "+351", "code": "PT" },
    { "name": "Puerto Rico", "dial_code": "+1939", "code": "PR" },
    { "name": "Qatar", "dial_code": "+974", "code": "QA" }, { "name": "Romania", "dial_code": "+40", "code": "RO" },
    { "name": "Russia", "dial_code": "+7", "code": "RU" },
    { "name": "Rwanda", "dial_code": "+250", "code": "RW" },
    { "name": "Reunion", "dial_code": "+262", "code": "RE" },
    { "name": "Saint Barthelemy", "dial_code": "+590", "code": "BL" },
    { "name": "Saint Helena, Ascension and Tristan Da Cunha", "dial_code": "+290", "code": "SH" },
    { "name": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN" },
    { "name": "Saint Lucia", "dial_code": "+1758", "code": "LC" },
    { "name": "Saint Martin", "dial_code": "+590", "code": "MF" },
    { "name": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM" },
    { "name": "Saint Vincent and the Grenadines", "dial_code": "+1784", "code": "VC" },
    { "name": "Samoa", "dial_code": "+685", "code": "WS" },
    { "name": "San Marino", "dial_code": "+378", "code": "SM" },
    { "name": "Sao Tome and Principe", "dial_code": "+239", "code": "ST" },
    { "name": "Saudi Arabia", "dial_code": "+966", "code": "SA" },
    { "name": "Senegal", "dial_code": "+221", "code": "SN" },
    { "name": "Serbia", "dial_code": "+381", "code": "RS" },
    { "name": "Seychelles", "dial_code": "+248", "code": "SC" },
    { "name": "Sierra Leone", "dial_code": "+232", "code": "SL" },
    { "name": "Singapore", "dial_code": "+65", "code": "SG" },
    { "name": "Slovakia", "dial_code": "+421", "code": "SK" },
    { "name": "Slovenia", "dial_code": "+386", "code": "SI" },
    { "name": "Solomon Islands", "dial_code": "+677", "code": "SB" },
    { "name": "Somalia", "dial_code": "+252", "code": "SO" },
    { "name": "South Africa", "dial_code": "+27", "code": "ZA" },
    { "name": "South Sudan", "dial_code": "+211", "code": "SS" },
    { "name": "South Georgia and the South Sandwich Islands", "dial_code": "+500", "code": "GS" },
    { "name": "Spain", "dial_code": "+34", "code": "ES" },
    { "name": "Sri Lanka", "dial_code": "+94", "code": "LK" },
    { "name": "Sudan", "dial_code": "+249", "code": "SD" },
    { "name": "Suriname", "dial_code": "+597", "code": "SR" },
    { "name": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ" },
    { "name": "Swaziland", "dial_code": "+268", "code": "SZ" }, { "name": "Sweden", "dial_code": "+46", "code": "SE" },
    { "name": "Switzerland", "dial_code": "+41", "code": "CH" },
    { "name": "Syrian Arab Republic", "dial_code": "+963", "code": "SY" },
    { "name": "Taiwan", "dial_code": "+886", "code": "TW" },
    { "name": "Tajikistan", "dial_code": "+992", "code": "TJ" },
    { "name": "Tanzania, United Republic of Tanzania", "dial_code": "+255", "code": "TZ" },
    { "name": "Thailand", "dial_code": "+66", "code": "TH" },
    { "name": "Timor-Leste", "dial_code": "+670", "code": "TL" },
    { "name": "Togo", "dial_code": "+228", "code": "TG" },
    { "name": "Tokelau", "dial_code": "+690", "code": "TK" },
    { "name": "Tonga", "dial_code": "+676", "code": "TO" },
    { "name": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT" },
    { "name": "Tunisia", "dial_code": "+216", "code": "TN" }, { "name": "Turkey", "dial_code": "+90", "code": "TR" },
    { "name": "Turkmenistan", "dial_code": "+993", "code": "TM" },
    { "name": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC" },
    { "name": "Tuvalu", "dial_code": "+688", "code": "TV" },
    { "name": "Uganda", "dial_code": "+256", "code": "UG" },
    { "name": "Ukraine", "dial_code": "+380", "code": "UA" },
    { "name": "United Arab Emirates", "dial_code": "+971", "code": "AE" },
    { "name": "United Kingdom", "dial_code": "+44", "code": "GB" },
    { "name": "UK", "dial_code": "+44", "code": "GB" },
    { "name": "United States of America (USA)", "dial_code": "+1", "code": "US" },
    { "name": "Uruguay", "dial_code": "+598", "code": "UY" },
    { "name": "Uzbekistan", "dial_code": "+998", "code": "UZ" },
    { "name": "Vanuatu", "dial_code": "+678", "code": "VU" },
    { "name": "Venezuela, Bolivarian Republic of Venezuela", "dial_code": "+58", "code": "VE" },
    { "name": "Vietnam", "dial_code": "+84", "code": "VN" },
    { "name": "Virgin Islands, British", "dial_code": "+1284", "code": "VG" },
    { "name": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI" },
    { "name": "Wallis and Futuna", "dial_code": "+681", "code": "WF" },
    { "name": "Yemen", "dial_code": "+967", "code": "YE" },
    { "name": "Zambia", "dial_code": "+260", "code": "ZM" },
    { "name": "Zimbabwe", "dial_code": "+263", "code": "ZW" }
];
/*
   Linkify
   -----------------------
   Add class js-linkify and set data-href to URL to make any DOM node a link
*/

$.fn.linkify = function($attachedParent, selector) {
	var $p = $attachedParent ? $attachedParent : $(document);
	var s = selector ? selector : '.js-linkify';

	$p.clickTap(s, function() {
		window.location.href = $(this).data().href;
	});
};
function applyMarketoButtonOffset() {
    $('#certifyForm').find('.mktoButtonWrap')
        .prepend('<label>&nbsp;</label>')
}

function cleanMarketoMarkup(){
    // hacks to override janky Marketo styling
    $('#certifyForm').find('style').remove();
    $('#certifyForm').find('.mktoFieldWrap')
        .addClass('inputWrap');

    // remove unnecessary gutter divs that can mess with flexbox
    $('.mktoOffset, .mktoGutter').remove();

    // remove static widths from all fields
    $('#certifyForm').find('input, select, textarea, label, .mktoLogicalField').attr('style','')

    $('#certifyForm').find('.mktoButtonWrap')
        .removeClass('mktoSimple')
        .addClass('inputWrap')
        .attr('style', '');

    $('#certifyForm').find('.mktoButton')
        .addClass('btn btn-cta btn-orange');
}

function loadMarketoForm(formId, accountId) {
    var acctId = accountId || '496-CPG-762';

    MktoForms2.loadForm("//info.emburse.com", acctId, formId, function (form) {
        $("#certifyForm").append(form.getFormElem());
        
        applyMarketoButtonOffset();
        cleanMarketoMarkup();
    });


    // anytime a form value changes, clean marketo markup again, since 
    // new fields may have been added dynamically. For example, the state field
    // is added after "United States" is selected for "Country".
    $('#certifyForm').on('change', '.mktoField', function () {
        window.requestAnimationFrame(cleanMarketoMarkup);
    });
}
// ********************************************************
// METHODS FOR EMBEDDING CERTIFY'S EXTERNALLY HOSTED MEDIA
// ********************************************************
(function(E) {
   var $videoLink;
   var videoId = 1;
   var defaults = {
      playerColor: '0a6cb5',
      videoFoam: false,
      fullscreenButton: true
   };

   // define base URL for video thumbnail image
   var thumbnailUrlBase = "https://fast.wistia.com/oembed/?url=" + escape("http://certify.wistia.com/medias/");
   var isLink = function($elem) {
      return $elem.is('a');
   };

   function deferLoad(f,params) {
      if(document.readyState === 'complete') {
         f(params[0],params[1],params[2]);
         return;
      }
      $(window).on('load',function() {
         f(params,params[0],params[1],params[2]);
      });
   }

   var buildDeviceWrapper = function(options) {
      // do this in pure JS
      var currentElem;
      var deviceOuter = document.createElement('div');
      deviceOuter.className = 'device-wrap ' + 'device-wrap--' + options.deviceType + ' device-wrap--' + options.deviceColor;

      var innerElems = ['top-bar','power','volume-controls','camera','sensor','speaker','screen','home-btn','bottom-bar'];
      var deviceInner = $.each(innerElems,function(i,elemClass) {
         currentElem = document.createElement('div');
         currentElem.className = elemClass;
         deviceOuter.appendChild(currentElem);
      });

      return $(deviceOuter);
   };

   function getAndAppendThumbnail($elem,videoId,options) {
      // this appends the thumbnail image to the wrapping element ($elem)
      // options set in embed callback will be applied here. If not set, defaults are used
      $.getJSON(thumbnailUrlBase + videoId + "&format=json&callback=?",function(json) {
         var imgPath = json.thumbnail_url + '&image_play_button=' + options.showPlayButton + '&image_play_button_color=' + options.playerColor + '&image_crop_resized=' + options.width + 'x' + options.height;
         $elem.append('<img class="wistia-popover-thumbnail" src="' + imgPath + '" width="' + options.width + '" height="' + options.height + '">');
      });
   }

   E.Wistia = (function() {
      var init = {
         inline: false,
         popover: false
      };
      var ready = {
         inline: false,
         popover: false
      };
      var deferred = {
         inline: [],
         popover: []
      };
      var defaults = {
         inline: defaults,
         popover: $.extend(defaults,{
            width: 640,
            height: 480,
            showPlayButton: true,
            getThumbnail: true

         })
      };
      var embed = {
         // wistia inline embed
         inline: function(args) {
            var $elem = args[0];
            var videoId = args[1];
            var options = args[2];
            var width = args[3] ? 'width:' + args[3][0] + 'px;' : '';
            var height = args[3] ? 'height:' + args[3][1] + 'px;' : '';
            options = $.extend(defaults.inline,options);
            $elem.append('<div id="wistia_' + videoId + '" class="wistia-embed_video" style="' + height + width + '"' + '></div>');
            wistiaEmbed = Wistia.embed(videoId,options);
         },

         // wistia popover embed
         popover: function(argsArray) {
            var $elem = argsArray[0];
            var videoId = argsArray[1];
            var options = argsArray[2];

            options = $.extend(defaults.popover,options);
            videoId = videoId || $elem.attr('id');

            if(isLink($elem)) {
               $videoLink = $elem;
            } else {
               // wrap $elem in anchor to initialize popover if $elem is not an anchor already
               $elem.wrapInner('<a id="video_' + videoId + '"></a>');
               $videoLink = $('#video_' + videoId);
            }

            $videoLink.addClass('popover-video-link wistia-popover[width=640,height=360,playerColor=#' + options.playerColor + ']')
              .attr('href','//fast.wistia.net/embed/iframe/' + videoId + '?popover=true');
            if(options.getThumbnail) {
               getAndAppendThumbnail($videoLink,videoId,options);
            }
         }
      };

      var getScript = {
         inline: function(callback) {
            init.inline = true;
            jQuery.ajax({
               url: "https://fast.wistia.com/assets/external/E-v1.js",
               dataType: "script",
               cache: true
            }).done(function() {
               inlineInit = true;
               callback();
            });
         },
         popover: function(callback) {
            init.popover = true;
            jQuery.ajax({
               url: "https://fast.wistia.com/assets/external/popover-v1.js",
               dataType: "script",
               cache: true
            }).done(function() {
               popoverInit = true;
               callback();
            });
         }
      };


      function getScriptAndEmbed(type,callbackArgs) {
         if(!init[type]) {
            // fetch script if it has not alredy been fetched
            getScript[type](function() {
               ready[type] = true;
               // batch process any deferred embeds once script has finished loading
               if(deferred[type].length) {
                  $.each(deferred[type],function(i,deferredArgs) {
                     embed[type](deferredArgs);
                  });
                  deferred[type] = [];
               }
            });
         }
         // catch any embeds that are loaded before embed script is ready
         // these will be loaded in a batch once the script download is complete.

         deferred[type].push(callbackArgs);
      }

      function embedHandler(type,callbackArgs) {

         // callback is the function that calls for the embed type e.g. embed.inline($elem,videoId,options);
         if(ready[type]) {
            // if script is ready, execute immediately
            embed[type](callbackArgs);
            return;
         }

         // if window loaded, fetch script / videos now
         if(document.readyState === 'complete') {
            getScriptAndEmbed(type,callbackArgs);
            return;
         }

         // if window not loaded, wait until it is to fetch script/video
         $(window).on('load',function() {
            getScriptAndEmbed(type,callbackArgs);
         });
      }

      // *****************
      // PUBLIC METHODS
      // *****************

      /*---------------------------------------------------------------------------------------------
        -embed a video from the Wistia Library by attaching it to a dom node and
         passing its video ID (you can get this from the URL string wistia's embed code generates)
         an optional options object can be passed
  
        -Video can either be embedded inline or as a "popover". Popover embed generates an iframe
         with video inside a modal that must be clicked on to open.
  
        -NOTE: the getScript methods for popover and inline embeds have been made available for
         cases where the script is required, but videos have been otherwise embedded.
         these can be accessed via EmbedMedia.Wistia.getPopoverScript & EmbedMedia.Wistia.getInlineScript
      -----------------------------------------------------------------------------------------------*/

      var inline = function($elem,videoId,options) {

         // OPTIONS:
         // -see wistia documentation for available player API methods
         // -http://wistia.com/doc/player-api
         options = $.extend(defaults.inline,options);

         // embedhandler will determine how to load video based on document and script ready state.
         embedHandler('inline',[$elem,videoId,options]);
      };

      var popover = function($elem,videoId,options) {
         // OPTIONS:
         // -Set embed height,width, whether to wrap in a link, and 
         // whether to get the video thumbnail generated by Wistia. 
         options = $.extend(defaults.popover,options);

         // embedhandler will determine how to load video based on document and script ready state.
         embedHandler('popover',[$elem,videoId,options]);
      };

      var _page;

      var buildAndAppendModalContainer = function() {
         _page = $('.page')[0];

         var _modalContainer = document.createElement('div');
         _modalContainer.className = 'mobilepopover modal';

         var _modalWrapper = document.createElement('div');

         _modalWrapper.className = 'mobilepopover_wrapper';
         _modalContainer.appendChild(_modalWrapper);
         _page.appendChild(_modalContainer);
         return $(_modalContainer);
      };

      var buildAndAppendModalBackground = function() {
         var _modalBackground = document.createElement('div');
         _modalBackground.className = 'mobilepopover_modalbg';

         _page.appendChild(_modalBackground);
         return $(_modalBackground);
      };

      var useModalPlayer = function() {
         return $(window).width() > 768 && $(window).width() > 420;
       };

      function playVid($vid) {
         $vid.trigger('play');
      }

      function pauseVid($vid,manualPause) {
         if(manualPause) {
            // if we trigger a manual pause, our default pause will fire and remove the 'playing' class, so we return here.
            $vid.trigger('pause');
            return;
         }
      }

      function activateModal(videoId,autoPlay) {
         // update video variables
         $currentVideoWrap = $('#wistia_' + videoId);
         $currentVideo = $currentVideoWrap.find('video');
         if(!$currentVideo.length) {
            // do nothing if video has not been added to the DOM yet
            return;
         }

         $mpContainer.addClass('modal-showing');
         $currentVideoWrap.addClass('active');

         if(autoPlay) {
            setTimeout(function() {
               playVid($currentVideo);
            },300);
          }

          //If mobile device = true, add close button to phone wrapper
          if ($(window).width() < 765) {
              var body = $('body');
              var head = $('head');
              var phoneWrap = $('.device-wrap--iPhone5s');

              $(body).addClass("wistia-fancybox");
              $(body).append('<link rel="stylesheet" id="wistia_popover_css" href="https://fast.wistia.net/assets/stylesheets/jquery.fancybox.css">');

              $(phoneWrap).prepend('<div title="Close" class="fancybox-item fancybox-close"  style="background-color: rgb(0, 107, 184);"></div>');

              $(".fancybox-close").bind("click", function () {
                  deactivateModal();
              });
          }

       } // end activateModal()

      function deactivateModal() {
         $mpContainer.removeClass('modal-showing');

         // current video is updated each time activate modal is called so these
         // variables will always be appropriate.
         $currentVideoWrap.removeClass('active');
         pauseVid($currentVideo,true);
       }

      var mobilePopoverBuilt = false;

      var $mpContainer,
          // sibling of mpContainer
          $modalBg,
          //child of mpContainer
          $mpWrap,
          // children of mpWrap
          $modalClose,
          $device,

          // settings
          vidWidth,
          vidHeight,
          vidResizeTimer;

      var mobilePopover = function($elem,videoId,options) {
         var defaults = {
            getThumbnail: true,
            deviceType: 'iPhone6',
            deviceColor: 'dark',
            hideDevice: true,
            playOnActivate: false,
            fullscreenButton: true
         };

         options = $.extend(defaults,options);

         var $modalActivator = $elem || options.activator;
         $modalActivator
           .data('videoId',videoId)
           .data('autoPlay',options.playOnActivate);

         /*
         *  BUILD MOBILE POPOVER MODAL
         *  
         *  Only needs to be done once
         *  for all videos on page
         *  ----------------------------------- */

         if(!mobilePopoverBuilt) {
            //mpwrap created here

            // this container will keep the video and device together and allow it to have position:absolute when the modal is active
            $mpContainer = buildAndAppendModalContainer();

            // append modalBG as sibling of modal container
            $modalBg = buildAndAppendModalBackground();

            // append device wrapper to popover container
            $mpWrap = $('.mobilepopover_wrapper');
            $mpWrap.append('<div class="mobilepopover_close"></div>');

            // build device
            $device = buildDeviceWrapper(options);
            // append device to device wrapper
            $mpWrap.append($device);

            vidWidth = $device.width() - 2; // - 2 accounts for border
            vidHeight = $device.height() - 2; // - 2 accounts for border

            $mpContainer.css({
               width: $device.outerWidth(),
               height: $device.outerHeight()
            });

            // modal acivation + configuration events
            $modalBg.add('.mobilepopover_close').on('click',function(e) {
               if(e.currentTarget !== e.target) { return false; }
               deactivateModal();
            });

            $(window).on('resize',function() {
               clearTimeout(vidResizeTimer);
               vidResizeTimer = setTimeout(
                 function() {
                    if(!useModalPlayer()) {
                       deactivateModal();
                       $mpContainer.addClass('mobile-size');
                    } else {
                       $mpContainer.removeClass('mobile-size');
                    }
                    //setVideoSize($embedWrap);
                 },100);
            });

            if(!useModalPlayer()) {
               $mpContainer.addClass('mobile-size');
            }

            mobilePopoverBuilt = true;
         }

         $modalActivator.on('click',function(e) {
            activateModal($(this).data().videoId,$(this).data().playOnActivate);
         });


         // Configure video for playback
         // ------------------------------ 

         // append video as sibling of device. It will be absolutely positioned over the device screen
         embedHandler('inline',[$mpWrap,videoId,options,[vidWidth,vidHeight]]);

      };

      return {
         'inline': inline,
         'popover': popover,
         'mobilePopover': mobilePopover,
         'getPopoverScript': getScript.popover,
         'getInlineScript': getScript.inline
      };
   })();

})(window.EmbedMedia = window.EmbedMedia || {});


// *************************
// Header Elements Reference
// *************************
// -- Defined @lib/scripts.js

var $headerContainer,	    // $('.page_header')
    $topNav,			    // $('.nav-top')
    $topNavItems,			// $('.nav-top_item')
    $subNav,				// $('.nav-dropdown')
    $subNavGroups,			// $('.nav-dropdown_group')
    $subNavLists,			// $('.nav-dropdown_list')
    $subNavItemHeaders,	    // $('.nav-dropdown_header')
    $microNav,				// $('.nav-top-collapsed')
    $microNavIcon;			// $('.nav-top-collapsed_toggle')

// *************************
// Header / Nav Helpers
// *************************

var booMicroNavShowing = false;
var booMobileDetect = function(m) {

    if ($(window).width() < 765) {
        return true;
    }
    else {
        return false;
    }
};

var intCurrentNavIndex = 0;


//************************************
// NAV UTITLITY FUNCTIONS & VARIABLES
//************************************

var subNavStyles = {};
var topNavStyles = {};
var subNavListStyles = {};
var subNavOffset;


//*************************
// FULL NAV FUNCTIONS
//*************************

function hideAllNavGroups() {
    if (!booMobileDetect()) {
        $('.nav-dropdown_group').hide();
    }

    //Remove bottom border on NavItems
    $('.js-topNavToggle').removeClass('active');

    intCurrentNavIndex = -1;
    window.booNavDropdownOpen = false;
}

function displayCurrentSubNav(index) {
    var $currentNavGroup = $('#subNavGroup' + index);
    var $currentNavList = $currentNavGroup.find('.nav-dropdown_list');
    var menuOffset = $('#topNavItem' + index).offset().left + pxToPercent($topNav.innerWidth(), .1);

    //Add bottom border on hovered NavItem
    $('#topNavItem' + index).addClass('active');

    //ensure .subNavList is visible because it may be hidden from using micro nav.
    // if a subnav is already showing, don't animate slide down

    //Hide all other dropdown menus
    $('.nav-dropdown_group').hide();

    $currentNavList
        .show()
        .css('left', '0');

    $subNav.css('left', menuOffset);
    $subNavGroups.css('left', '0');
    $currentNavGroup.slideDown(150);
}

function showSubNav(index) {
    //Stop here if toggling a sub nav that is already open
    if (intCurrentNavIndex === index) {
        return;
    }

    // make sure subnav is visible
    $subNav.show();

    // if another sub nav is open, close it
    hideAllNavGroups();

    // show and position the selected subnav
    displayCurrentSubNav(index);

    window.booNavDropdownOpen = true;

    // save reference to current visible subnav
    intCurrentNavIndex = index;
}

//Sets subnav position depending on desktop/mobile state
function setSubNavState() {
    subNavOffset = $headerContainer.outerHeight();

    if (booMobileDetect()) {
        subNavStyles = {
            'top': subNavOffset,
            'left': ''
        };

        // if micro nav is not currently showing, hide all subnav lists
        // each one should start out collapsed
        if (!booMicroNavShowing) {
            $('.nav-dropdown_list').css({
                left: 0,
                display: 'none'
            });
        }
    } else {
        // hide micronav if it is visible and we have sized up to desktop size
        if (booMicroNavShowing) {
            hideMicroNav();
        }
        var topNavOffset = Math.floor($('#topNavItem1').height()); // 1 compensates for line height
        // top will be int top figure
        topNavStyles = {
            'top': topNavOffset
        };
        subNavStyles = {
            'top': subNavOffset - 20,
            'left': 0
        };
    }

    $subNav.css(subNavStyles);
    $topNav.css(topNavStyles);
}


//************
// MICRO NAV ON MOBILE
//************

//Click Hamburger menu to open mobile drawer
$(document).clickTap('.js-microNavToggle', function () {
    toggleMicroNav();
});

function toggleMicroNav() {
    // we shouldn't need to do anything at all if we are NOT on mobile size, so stop here
    if (!booMobileDetect()) return;

    if (booMicroNavShowing) {
        hideMicroNav()
    }
    else {
        showMicroNav();
    }
}

function hideMicroNav() {
    // nav is already hidden
    if (!booMicroNavShowing) return;

    $('.nav-dropdown').addClass('close');
    $('.nav-dropdown').removeClass('open');
    $('#hamburger-animated').removeClass('open');

    // hide all navigation groups
    $('.nav-dropdown_group').hide();

    //Deactivate all Micro nav headers (removes blue left-border styling)
    $('.js-microNavListToggle').removeClass('active');

    //Close all open dropdowns
    $subNavLists.each(function (i) {
        if ($(this).css('display', 'block')) {
            // close other open menus
            $(this).slideToggle(300);
        }
    });

    // detach event handler
    $(document).off('.close-mobilenav');

    //Delay removal of 'close' since this contains left transition which we only want occuring during actual close
    setTimeout(function () {
        $('.nav-dropdown').removeClass('close');
    }, 1000);

    booMicroNavShowing = false;
}

function showMicroNav() {
    // nav is already showing
    if (booMicroNavShowing) return;

    $('.nav-dropdown').addClass('open');
    $('.nav-dropdown').removeClass('close');
    $('#hamburger-animated').addClass('open');

    // show all navigation groups
    $('.nav-dropdown_group').show();

    // add event handler to close mobile nav on click outside of the page header
    $(document).on('click.close-mobilenav', function (e) {
        var $target = $(e.target);

        if (!$target.hasClass('page_header') && !$target.parents('.page_header').length) {
            hideMicroNav();
        }
    });

    booMicroNavShowing = true;
}

//Opens the correct micro-nav dropdown list
function toggleSubNavList(id) {
    var $target = $(id)
    $subNavLists.each(function(i) {
        if ($(this).attr('id') == id) {
            $(this).slideToggle(150);
        } else if ($(this).is(':visible')) {
            // close other open menus
            $(this).slideToggle(300);
        }
    });
}


//When resizing the screen from desktop to mid screen, this reinitializes the subNavOffset variable 
// since the header gets taller on mid-screen
window.onresize = function () {
    setSubNavState();
}

function loadNavEvents() {
    window.booNavDropdownOpen = false;

    $(window).on("orientationchange", function(e) {
        // when device orientation changes just hide the nav to avoid headaches
        hideMicroNav();
        hideAllNavGroups();
    });

    //Desktop
    $('.js-topNavToggle').hover(function() {
        var navIndex = $topNavItems.index($(this));
        showSubNav(navIndex);
    });

    // Handler to hide main navigation when mouse leaves header area
    // This is only valid for the primary nav
    $('.page_header').on('mouseleave', function () {
        // get out of here if we are in mobile nav mode
        if (window.booMobileDetect()) return;

        if (window.booNavDropdownOpen) {
            hideAllNavGroups();
        }
    });

    $(document).clickTap('.js-microNavListToggle', function() {
        var $target = $(this);
        var subNavListId = $target.attr('id').split('_')[1];
        var subNavHeight = $('.nav-top-collapsed').height() + $('.nav-dropdown').height();
        var newHeight = $(window).height() - $('.nav-top-collapsed').height();

        // toggle this micronav list header's active state
        $target.not('.actual-link').toggleClass('active');

        //Remove active classes from all other micronav headers
        $('.js-microNavListToggle').not($target).removeClass('active');

        //apply overflow-y: auto if needed
        if ($(window).height() < subNavHeight) {
            $('.nav-dropdown').css('max-height', newHeight);
            $('.nav-dropdown').css('overflow-y', 'auto');
        }

        // show links for this subnav group
        toggleSubNavList('subNavList_' + subNavListId);

        //If user clicks link (not dropdown) it will redirect to url. Can't get link to work on its own.
        if ($target.hasClass('actual-link')) {
            var href = $target.find('a').attr('href');

            window.location.href = href;
        }
    });

    // set initial nav offset on load
    setSubNavState();
}
$(function() {
	// @modules/nav.js
	// Populate Nav Module variables
	$headerContainer = $('.page_header');
	$topNav = $('.nav-top');
	$topNavItems = $('.nav-top_item');
	$subNav = $('.nav-dropdown');
	$subNavGroups = $('.nav-dropdown_group');
	$subNavLists = $('.nav-dropdown_list');
	$subNavItemHeaders = $('.nav-dropdown_header');
	$microNav = $('.nav-top-collapsed');
	$microNavIcon = $('.nav-top-collapsed_toggle');

	loadNavEvents();


	/**************************************/


	// @modules/forms.js
    window.Form = new FormConstructor();

	// check to see if there is any form data which needs to be submitted.
	// if there are submit them now. This will NOT affect any other forms which
	// may be on the page 
	Storage.session.keys().forEach(function(key) {
		if (key.indexOf('postdata') === 0) {
			try {
				var postUrl = Storage.session.get(key)
	
				Form.submitDataToEndpointDelayed(key, postUrl);
			} catch (err) {
				console.log(err);
				// do nothing
			}
		}
	});
	

	// credit lead source from a referral partner if any
	if (urlParams.lc) {
		Form.creditLeadSource(urlParams.lc);
	}


	/**************************************/


	// @modules/linkify.js
    // converts any DOM node to a link
	if ($('.js-linkify').length) { $('.js-linkify').linkify(); }


	/**************************************/

	// @modules/centerToMedia.js
	$anchorMedia = $('.anchor-media-container');
	needsCTMFormatting = $anchorMedia.length > 0;

	if (needsCTMFormatting) {
		$(document).on('ready', function() {
			formatAllCTMPanels();
		});
		$(window).on('resize', function() {
			clearTimeout(throttleCTM);
			throttleCTM = setTimeout(formatAllCTMPanels, 100);
		});
	}

	// *****************************************************************
	// Add container class to VP wrapper if no other container on page
	// *****************************************************************

	if ($('#Form1').find('.container').length < 1 && $('#Form1').find('.page_content--contained').length < 1) {
		$('#Form1').addClass('container');
	}

 }
});












